-- | GENERATED by tools/sync-verbs.mjs - do not edit.
-- |
-- | Source: data/es-verbs.csv (38 verbs, 760 cells, irregular verbs only).
module Flashcards.Data.Verbs.Spanish
  ( deviations
  , table
  )
  where

import Flashcards.Verbs.Table (Cell, Deviation, Person(..), Tense(..))

-- | One entry per cell, grouped by verb, then tense, then person.
table :: Array Cell
table =
  [ { infinitive: "ser", tense: Present, person: Sg1, form: "soy" }
  , { infinitive: "ser", tense: Present, person: Sg2, form: "eres" }
  , { infinitive: "ser", tense: Present, person: Sg3, form: "es" }
  , { infinitive: "ser", tense: Present, person: Pl1, form: "somos" }
  , { infinitive: "ser", tense: Present, person: Pl3, form: "son" }
  , { infinitive: "ser", tense: Preterite, person: Sg1, form: "fui" }
  , { infinitive: "ser", tense: Preterite, person: Sg2, form: "fuiste" }
  , { infinitive: "ser", tense: Preterite, person: Sg3, form: "fue" }
  , { infinitive: "ser", tense: Preterite, person: Pl1, form: "fuimos" }
  , { infinitive: "ser", tense: Preterite, person: Pl3, form: "fueron" }
  , { infinitive: "ser", tense: Imperfect, person: Sg1, form: "era" }
  , { infinitive: "ser", tense: Imperfect, person: Sg2, form: "eras" }
  , { infinitive: "ser", tense: Imperfect, person: Sg3, form: "era" }
  , { infinitive: "ser", tense: Imperfect, person: Pl1, form: "éramos" }
  , { infinitive: "ser", tense: Imperfect, person: Pl3, form: "eran" }
  , { infinitive: "ser", tense: Subjunctive, person: Sg1, form: "sea" }
  , { infinitive: "ser", tense: Subjunctive, person: Sg2, form: "seas" }
  , { infinitive: "ser", tense: Subjunctive, person: Sg3, form: "sea" }
  , { infinitive: "ser", tense: Subjunctive, person: Pl1, form: "seamos" }
  , { infinitive: "ser", tense: Subjunctive, person: Pl3, form: "sean" }
  , { infinitive: "estar", tense: Present, person: Sg1, form: "estoy" }
  , { infinitive: "estar", tense: Present, person: Sg2, form: "estás" }
  , { infinitive: "estar", tense: Present, person: Sg3, form: "está" }
  , { infinitive: "estar", tense: Present, person: Pl1, form: "estamos" }
  , { infinitive: "estar", tense: Present, person: Pl3, form: "están" }
  , { infinitive: "estar", tense: Preterite, person: Sg1, form: "estuve" }
  , { infinitive: "estar", tense: Preterite, person: Sg2, form: "estuviste" }
  , { infinitive: "estar", tense: Preterite, person: Sg3, form: "estuvo" }
  , { infinitive: "estar", tense: Preterite, person: Pl1, form: "estuvimos" }
  , { infinitive: "estar", tense: Preterite, person: Pl3, form: "estuvieron" }
  , { infinitive: "estar", tense: Imperfect, person: Sg1, form: "estaba" }
  , { infinitive: "estar", tense: Imperfect, person: Sg2, form: "estabas" }
  , { infinitive: "estar", tense: Imperfect, person: Sg3, form: "estaba" }
  , { infinitive: "estar", tense: Imperfect, person: Pl1, form: "estábamos" }
  , { infinitive: "estar", tense: Imperfect, person: Pl3, form: "estaban" }
  , { infinitive: "estar", tense: Subjunctive, person: Sg1, form: "esté" }
  , { infinitive: "estar", tense: Subjunctive, person: Sg2, form: "estés" }
  , { infinitive: "estar", tense: Subjunctive, person: Sg3, form: "esté" }
  , { infinitive: "estar", tense: Subjunctive, person: Pl1, form: "estemos" }
  , { infinitive: "estar", tense: Subjunctive, person: Pl3, form: "estén" }
  , { infinitive: "ir", tense: Present, person: Sg1, form: "voy" }
  , { infinitive: "ir", tense: Present, person: Sg2, form: "vas" }
  , { infinitive: "ir", tense: Present, person: Sg3, form: "va" }
  , { infinitive: "ir", tense: Present, person: Pl1, form: "vamos" }
  , { infinitive: "ir", tense: Present, person: Pl3, form: "van" }
  , { infinitive: "ir", tense: Preterite, person: Sg1, form: "fui" }
  , { infinitive: "ir", tense: Preterite, person: Sg2, form: "fuiste" }
  , { infinitive: "ir", tense: Preterite, person: Sg3, form: "fue" }
  , { infinitive: "ir", tense: Preterite, person: Pl1, form: "fuimos" }
  , { infinitive: "ir", tense: Preterite, person: Pl3, form: "fueron" }
  , { infinitive: "ir", tense: Imperfect, person: Sg1, form: "iba" }
  , { infinitive: "ir", tense: Imperfect, person: Sg2, form: "ibas" }
  , { infinitive: "ir", tense: Imperfect, person: Sg3, form: "iba" }
  , { infinitive: "ir", tense: Imperfect, person: Pl1, form: "íbamos" }
  , { infinitive: "ir", tense: Imperfect, person: Pl3, form: "iban" }
  , { infinitive: "ir", tense: Subjunctive, person: Sg1, form: "vaya" }
  , { infinitive: "ir", tense: Subjunctive, person: Sg2, form: "vayas" }
  , { infinitive: "ir", tense: Subjunctive, person: Sg3, form: "vaya" }
  , { infinitive: "ir", tense: Subjunctive, person: Pl1, form: "vayamos" }
  , { infinitive: "ir", tense: Subjunctive, person: Pl3, form: "vayan" }
  , { infinitive: "tener", tense: Present, person: Sg1, form: "tengo" }
  , { infinitive: "tener", tense: Present, person: Sg2, form: "tienes" }
  , { infinitive: "tener", tense: Present, person: Sg3, form: "tiene" }
  , { infinitive: "tener", tense: Present, person: Pl1, form: "tenemos" }
  , { infinitive: "tener", tense: Present, person: Pl3, form: "tienen" }
  , { infinitive: "tener", tense: Preterite, person: Sg1, form: "tuve" }
  , { infinitive: "tener", tense: Preterite, person: Sg2, form: "tuviste" }
  , { infinitive: "tener", tense: Preterite, person: Sg3, form: "tuvo" }
  , { infinitive: "tener", tense: Preterite, person: Pl1, form: "tuvimos" }
  , { infinitive: "tener", tense: Preterite, person: Pl3, form: "tuvieron" }
  , { infinitive: "tener", tense: Imperfect, person: Sg1, form: "tenía" }
  , { infinitive: "tener", tense: Imperfect, person: Sg2, form: "tenías" }
  , { infinitive: "tener", tense: Imperfect, person: Sg3, form: "tenía" }
  , { infinitive: "tener", tense: Imperfect, person: Pl1, form: "teníamos" }
  , { infinitive: "tener", tense: Imperfect, person: Pl3, form: "tenían" }
  , { infinitive: "tener", tense: Subjunctive, person: Sg1, form: "tenga" }
  , { infinitive: "tener", tense: Subjunctive, person: Sg2, form: "tengas" }
  , { infinitive: "tener", tense: Subjunctive, person: Sg3, form: "tenga" }
  , { infinitive: "tener", tense: Subjunctive, person: Pl1, form: "tengamos" }
  , { infinitive: "tener", tense: Subjunctive, person: Pl3, form: "tengan" }
  , { infinitive: "hacer", tense: Present, person: Sg1, form: "hago" }
  , { infinitive: "hacer", tense: Present, person: Sg2, form: "haces" }
  , { infinitive: "hacer", tense: Present, person: Sg3, form: "hace" }
  , { infinitive: "hacer", tense: Present, person: Pl1, form: "hacemos" }
  , { infinitive: "hacer", tense: Present, person: Pl3, form: "hacen" }
  , { infinitive: "hacer", tense: Preterite, person: Sg1, form: "hice" }
  , { infinitive: "hacer", tense: Preterite, person: Sg2, form: "hiciste" }
  , { infinitive: "hacer", tense: Preterite, person: Sg3, form: "hizo" }
  , { infinitive: "hacer", tense: Preterite, person: Pl1, form: "hicimos" }
  , { infinitive: "hacer", tense: Preterite, person: Pl3, form: "hicieron" }
  , { infinitive: "hacer", tense: Imperfect, person: Sg1, form: "hacía" }
  , { infinitive: "hacer", tense: Imperfect, person: Sg2, form: "hacías" }
  , { infinitive: "hacer", tense: Imperfect, person: Sg3, form: "hacía" }
  , { infinitive: "hacer", tense: Imperfect, person: Pl1, form: "hacíamos" }
  , { infinitive: "hacer", tense: Imperfect, person: Pl3, form: "hacían" }
  , { infinitive: "hacer", tense: Subjunctive, person: Sg1, form: "haga" }
  , { infinitive: "hacer", tense: Subjunctive, person: Sg2, form: "hagas" }
  , { infinitive: "hacer", tense: Subjunctive, person: Sg3, form: "haga" }
  , { infinitive: "hacer", tense: Subjunctive, person: Pl1, form: "hagamos" }
  , { infinitive: "hacer", tense: Subjunctive, person: Pl3, form: "hagan" }
  , { infinitive: "poder", tense: Present, person: Sg1, form: "puedo" }
  , { infinitive: "poder", tense: Present, person: Sg2, form: "puedes" }
  , { infinitive: "poder", tense: Present, person: Sg3, form: "puede" }
  , { infinitive: "poder", tense: Present, person: Pl1, form: "podemos" }
  , { infinitive: "poder", tense: Present, person: Pl3, form: "pueden" }
  , { infinitive: "poder", tense: Preterite, person: Sg1, form: "pude" }
  , { infinitive: "poder", tense: Preterite, person: Sg2, form: "pudiste" }
  , { infinitive: "poder", tense: Preterite, person: Sg3, form: "pudo" }
  , { infinitive: "poder", tense: Preterite, person: Pl1, form: "pudimos" }
  , { infinitive: "poder", tense: Preterite, person: Pl3, form: "pudieron" }
  , { infinitive: "poder", tense: Imperfect, person: Sg1, form: "podía" }
  , { infinitive: "poder", tense: Imperfect, person: Sg2, form: "podías" }
  , { infinitive: "poder", tense: Imperfect, person: Sg3, form: "podía" }
  , { infinitive: "poder", tense: Imperfect, person: Pl1, form: "podíamos" }
  , { infinitive: "poder", tense: Imperfect, person: Pl3, form: "podían" }
  , { infinitive: "poder", tense: Subjunctive, person: Sg1, form: "pueda" }
  , { infinitive: "poder", tense: Subjunctive, person: Sg2, form: "puedas" }
  , { infinitive: "poder", tense: Subjunctive, person: Sg3, form: "pueda" }
  , { infinitive: "poder", tense: Subjunctive, person: Pl1, form: "podamos" }
  , { infinitive: "poder", tense: Subjunctive, person: Pl3, form: "puedan" }
  , { infinitive: "decir", tense: Present, person: Sg1, form: "digo" }
  , { infinitive: "decir", tense: Present, person: Sg2, form: "dices" }
  , { infinitive: "decir", tense: Present, person: Sg3, form: "dice" }
  , { infinitive: "decir", tense: Present, person: Pl1, form: "decimos" }
  , { infinitive: "decir", tense: Present, person: Pl3, form: "dicen" }
  , { infinitive: "decir", tense: Preterite, person: Sg1, form: "dije" }
  , { infinitive: "decir", tense: Preterite, person: Sg2, form: "dijiste" }
  , { infinitive: "decir", tense: Preterite, person: Sg3, form: "dijo" }
  , { infinitive: "decir", tense: Preterite, person: Pl1, form: "dijimos" }
  , { infinitive: "decir", tense: Preterite, person: Pl3, form: "dijeron" }
  , { infinitive: "decir", tense: Imperfect, person: Sg1, form: "decía" }
  , { infinitive: "decir", tense: Imperfect, person: Sg2, form: "decías" }
  , { infinitive: "decir", tense: Imperfect, person: Sg3, form: "decía" }
  , { infinitive: "decir", tense: Imperfect, person: Pl1, form: "decíamos" }
  , { infinitive: "decir", tense: Imperfect, person: Pl3, form: "decían" }
  , { infinitive: "decir", tense: Subjunctive, person: Sg1, form: "diga" }
  , { infinitive: "decir", tense: Subjunctive, person: Sg2, form: "digas" }
  , { infinitive: "decir", tense: Subjunctive, person: Sg3, form: "diga" }
  , { infinitive: "decir", tense: Subjunctive, person: Pl1, form: "digamos" }
  , { infinitive: "decir", tense: Subjunctive, person: Pl3, form: "digan" }
  , { infinitive: "poner", tense: Present, person: Sg1, form: "pongo" }
  , { infinitive: "poner", tense: Present, person: Sg2, form: "pones" }
  , { infinitive: "poner", tense: Present, person: Sg3, form: "pone" }
  , { infinitive: "poner", tense: Present, person: Pl1, form: "ponemos" }
  , { infinitive: "poner", tense: Present, person: Pl3, form: "ponen" }
  , { infinitive: "poner", tense: Preterite, person: Sg1, form: "puse" }
  , { infinitive: "poner", tense: Preterite, person: Sg2, form: "pusiste" }
  , { infinitive: "poner", tense: Preterite, person: Sg3, form: "puso" }
  , { infinitive: "poner", tense: Preterite, person: Pl1, form: "pusimos" }
  , { infinitive: "poner", tense: Preterite, person: Pl3, form: "pusieron" }
  , { infinitive: "poner", tense: Imperfect, person: Sg1, form: "ponía" }
  , { infinitive: "poner", tense: Imperfect, person: Sg2, form: "ponías" }
  , { infinitive: "poner", tense: Imperfect, person: Sg3, form: "ponía" }
  , { infinitive: "poner", tense: Imperfect, person: Pl1, form: "poníamos" }
  , { infinitive: "poner", tense: Imperfect, person: Pl3, form: "ponían" }
  , { infinitive: "poner", tense: Subjunctive, person: Sg1, form: "ponga" }
  , { infinitive: "poner", tense: Subjunctive, person: Sg2, form: "pongas" }
  , { infinitive: "poner", tense: Subjunctive, person: Sg3, form: "ponga" }
  , { infinitive: "poner", tense: Subjunctive, person: Pl1, form: "pongamos" }
  , { infinitive: "poner", tense: Subjunctive, person: Pl3, form: "pongan" }
  , { infinitive: "venir", tense: Present, person: Sg1, form: "vengo" }
  , { infinitive: "venir", tense: Present, person: Sg2, form: "vienes" }
  , { infinitive: "venir", tense: Present, person: Sg3, form: "viene" }
  , { infinitive: "venir", tense: Present, person: Pl1, form: "venimos" }
  , { infinitive: "venir", tense: Present, person: Pl3, form: "vienen" }
  , { infinitive: "venir", tense: Preterite, person: Sg1, form: "vine" }
  , { infinitive: "venir", tense: Preterite, person: Sg2, form: "viniste" }
  , { infinitive: "venir", tense: Preterite, person: Sg3, form: "vino" }
  , { infinitive: "venir", tense: Preterite, person: Pl1, form: "vinimos" }
  , { infinitive: "venir", tense: Preterite, person: Pl3, form: "vinieron" }
  , { infinitive: "venir", tense: Imperfect, person: Sg1, form: "venía" }
  , { infinitive: "venir", tense: Imperfect, person: Sg2, form: "venías" }
  , { infinitive: "venir", tense: Imperfect, person: Sg3, form: "venía" }
  , { infinitive: "venir", tense: Imperfect, person: Pl1, form: "veníamos" }
  , { infinitive: "venir", tense: Imperfect, person: Pl3, form: "venían" }
  , { infinitive: "venir", tense: Subjunctive, person: Sg1, form: "venga" }
  , { infinitive: "venir", tense: Subjunctive, person: Sg2, form: "vengas" }
  , { infinitive: "venir", tense: Subjunctive, person: Sg3, form: "venga" }
  , { infinitive: "venir", tense: Subjunctive, person: Pl1, form: "vengamos" }
  , { infinitive: "venir", tense: Subjunctive, person: Pl3, form: "vengan" }
  , { infinitive: "querer", tense: Present, person: Sg1, form: "quiero" }
  , { infinitive: "querer", tense: Present, person: Sg2, form: "quieres" }
  , { infinitive: "querer", tense: Present, person: Sg3, form: "quiere" }
  , { infinitive: "querer", tense: Present, person: Pl1, form: "queremos" }
  , { infinitive: "querer", tense: Present, person: Pl3, form: "quieren" }
  , { infinitive: "querer", tense: Preterite, person: Sg1, form: "quise" }
  , { infinitive: "querer", tense: Preterite, person: Sg2, form: "quisiste" }
  , { infinitive: "querer", tense: Preterite, person: Sg3, form: "quiso" }
  , { infinitive: "querer", tense: Preterite, person: Pl1, form: "quisimos" }
  , { infinitive: "querer", tense: Preterite, person: Pl3, form: "quisieron" }
  , { infinitive: "querer", tense: Imperfect, person: Sg1, form: "quería" }
  , { infinitive: "querer", tense: Imperfect, person: Sg2, form: "querías" }
  , { infinitive: "querer", tense: Imperfect, person: Sg3, form: "quería" }
  , { infinitive: "querer", tense: Imperfect, person: Pl1, form: "queríamos" }
  , { infinitive: "querer", tense: Imperfect, person: Pl3, form: "querían" }
  , { infinitive: "querer", tense: Subjunctive, person: Sg1, form: "quiera" }
  , { infinitive: "querer", tense: Subjunctive, person: Sg2, form: "quieras" }
  , { infinitive: "querer", tense: Subjunctive, person: Sg3, form: "quiera" }
  , { infinitive: "querer", tense: Subjunctive, person: Pl1, form: "queramos" }
  , { infinitive: "querer", tense: Subjunctive, person: Pl3, form: "quieran" }
  , { infinitive: "saber", tense: Present, person: Sg1, form: "sé" }
  , { infinitive: "saber", tense: Present, person: Sg2, form: "sabes" }
  , { infinitive: "saber", tense: Present, person: Sg3, form: "sabe" }
  , { infinitive: "saber", tense: Present, person: Pl1, form: "sabemos" }
  , { infinitive: "saber", tense: Present, person: Pl3, form: "saben" }
  , { infinitive: "saber", tense: Preterite, person: Sg1, form: "supe" }
  , { infinitive: "saber", tense: Preterite, person: Sg2, form: "supiste" }
  , { infinitive: "saber", tense: Preterite, person: Sg3, form: "supo" }
  , { infinitive: "saber", tense: Preterite, person: Pl1, form: "supimos" }
  , { infinitive: "saber", tense: Preterite, person: Pl3, form: "supieron" }
  , { infinitive: "saber", tense: Imperfect, person: Sg1, form: "sabía" }
  , { infinitive: "saber", tense: Imperfect, person: Sg2, form: "sabías" }
  , { infinitive: "saber", tense: Imperfect, person: Sg3, form: "sabía" }
  , { infinitive: "saber", tense: Imperfect, person: Pl1, form: "sabíamos" }
  , { infinitive: "saber", tense: Imperfect, person: Pl3, form: "sabían" }
  , { infinitive: "saber", tense: Subjunctive, person: Sg1, form: "sepa" }
  , { infinitive: "saber", tense: Subjunctive, person: Sg2, form: "sepas" }
  , { infinitive: "saber", tense: Subjunctive, person: Sg3, form: "sepa" }
  , { infinitive: "saber", tense: Subjunctive, person: Pl1, form: "sepamos" }
  , { infinitive: "saber", tense: Subjunctive, person: Pl3, form: "sepan" }
  , { infinitive: "ver", tense: Present, person: Sg1, form: "veo" }
  , { infinitive: "ver", tense: Present, person: Sg2, form: "ves" }
  , { infinitive: "ver", tense: Present, person: Sg3, form: "ve" }
  , { infinitive: "ver", tense: Present, person: Pl1, form: "vemos" }
  , { infinitive: "ver", tense: Present, person: Pl3, form: "ven" }
  , { infinitive: "ver", tense: Preterite, person: Sg1, form: "vi" }
  , { infinitive: "ver", tense: Preterite, person: Sg2, form: "viste" }
  , { infinitive: "ver", tense: Preterite, person: Sg3, form: "vio" }
  , { infinitive: "ver", tense: Preterite, person: Pl1, form: "vimos" }
  , { infinitive: "ver", tense: Preterite, person: Pl3, form: "vieron" }
  , { infinitive: "ver", tense: Imperfect, person: Sg1, form: "veía" }
  , { infinitive: "ver", tense: Imperfect, person: Sg2, form: "veías" }
  , { infinitive: "ver", tense: Imperfect, person: Sg3, form: "veía" }
  , { infinitive: "ver", tense: Imperfect, person: Pl1, form: "veíamos" }
  , { infinitive: "ver", tense: Imperfect, person: Pl3, form: "veían" }
  , { infinitive: "ver", tense: Subjunctive, person: Sg1, form: "vea" }
  , { infinitive: "ver", tense: Subjunctive, person: Sg2, form: "veas" }
  , { infinitive: "ver", tense: Subjunctive, person: Sg3, form: "vea" }
  , { infinitive: "ver", tense: Subjunctive, person: Pl1, form: "veamos" }
  , { infinitive: "ver", tense: Subjunctive, person: Pl3, form: "vean" }
  , { infinitive: "dar", tense: Present, person: Sg1, form: "doy" }
  , { infinitive: "dar", tense: Present, person: Sg2, form: "das" }
  , { infinitive: "dar", tense: Present, person: Sg3, form: "da" }
  , { infinitive: "dar", tense: Present, person: Pl1, form: "damos" }
  , { infinitive: "dar", tense: Present, person: Pl3, form: "dan" }
  , { infinitive: "dar", tense: Preterite, person: Sg1, form: "di" }
  , { infinitive: "dar", tense: Preterite, person: Sg2, form: "diste" }
  , { infinitive: "dar", tense: Preterite, person: Sg3, form: "dio" }
  , { infinitive: "dar", tense: Preterite, person: Pl1, form: "dimos" }
  , { infinitive: "dar", tense: Preterite, person: Pl3, form: "dieron" }
  , { infinitive: "dar", tense: Imperfect, person: Sg1, form: "daba" }
  , { infinitive: "dar", tense: Imperfect, person: Sg2, form: "dabas" }
  , { infinitive: "dar", tense: Imperfect, person: Sg3, form: "daba" }
  , { infinitive: "dar", tense: Imperfect, person: Pl1, form: "dábamos" }
  , { infinitive: "dar", tense: Imperfect, person: Pl3, form: "daban" }
  , { infinitive: "dar", tense: Subjunctive, person: Sg1, form: "dé" }
  , { infinitive: "dar", tense: Subjunctive, person: Sg2, form: "des" }
  , { infinitive: "dar", tense: Subjunctive, person: Sg3, form: "dé" }
  , { infinitive: "dar", tense: Subjunctive, person: Pl1, form: "demos" }
  , { infinitive: "dar", tense: Subjunctive, person: Pl3, form: "den" }
  , { infinitive: "salir", tense: Present, person: Sg1, form: "salgo" }
  , { infinitive: "salir", tense: Present, person: Sg2, form: "sales" }
  , { infinitive: "salir", tense: Present, person: Sg3, form: "sale" }
  , { infinitive: "salir", tense: Present, person: Pl1, form: "salimos" }
  , { infinitive: "salir", tense: Present, person: Pl3, form: "salen" }
  , { infinitive: "salir", tense: Preterite, person: Sg1, form: "salí" }
  , { infinitive: "salir", tense: Preterite, person: Sg2, form: "saliste" }
  , { infinitive: "salir", tense: Preterite, person: Sg3, form: "salió" }
  , { infinitive: "salir", tense: Preterite, person: Pl1, form: "salimos" }
  , { infinitive: "salir", tense: Preterite, person: Pl3, form: "salieron" }
  , { infinitive: "salir", tense: Imperfect, person: Sg1, form: "salía" }
  , { infinitive: "salir", tense: Imperfect, person: Sg2, form: "salías" }
  , { infinitive: "salir", tense: Imperfect, person: Sg3, form: "salía" }
  , { infinitive: "salir", tense: Imperfect, person: Pl1, form: "salíamos" }
  , { infinitive: "salir", tense: Imperfect, person: Pl3, form: "salían" }
  , { infinitive: "salir", tense: Subjunctive, person: Sg1, form: "salga" }
  , { infinitive: "salir", tense: Subjunctive, person: Sg2, form: "salgas" }
  , { infinitive: "salir", tense: Subjunctive, person: Sg3, form: "salga" }
  , { infinitive: "salir", tense: Subjunctive, person: Pl1, form: "salgamos" }
  , { infinitive: "salir", tense: Subjunctive, person: Pl3, form: "salgan" }
  , { infinitive: "traer", tense: Present, person: Sg1, form: "traigo" }
  , { infinitive: "traer", tense: Present, person: Sg2, form: "traes" }
  , { infinitive: "traer", tense: Present, person: Sg3, form: "trae" }
  , { infinitive: "traer", tense: Present, person: Pl1, form: "traemos" }
  , { infinitive: "traer", tense: Present, person: Pl3, form: "traen" }
  , { infinitive: "traer", tense: Preterite, person: Sg1, form: "traje" }
  , { infinitive: "traer", tense: Preterite, person: Sg2, form: "trajiste" }
  , { infinitive: "traer", tense: Preterite, person: Sg3, form: "trajo" }
  , { infinitive: "traer", tense: Preterite, person: Pl1, form: "trajimos" }
  , { infinitive: "traer", tense: Preterite, person: Pl3, form: "trajeron" }
  , { infinitive: "traer", tense: Imperfect, person: Sg1, form: "traía" }
  , { infinitive: "traer", tense: Imperfect, person: Sg2, form: "traías" }
  , { infinitive: "traer", tense: Imperfect, person: Sg3, form: "traía" }
  , { infinitive: "traer", tense: Imperfect, person: Pl1, form: "traíamos" }
  , { infinitive: "traer", tense: Imperfect, person: Pl3, form: "traían" }
  , { infinitive: "traer", tense: Subjunctive, person: Sg1, form: "traiga" }
  , { infinitive: "traer", tense: Subjunctive, person: Sg2, form: "traigas" }
  , { infinitive: "traer", tense: Subjunctive, person: Sg3, form: "traiga" }
  , { infinitive: "traer", tense: Subjunctive, person: Pl1, form: "traigamos" }
  , { infinitive: "traer", tense: Subjunctive, person: Pl3, form: "traigan" }
  , { infinitive: "caber", tense: Present, person: Sg1, form: "quepo" }
  , { infinitive: "caber", tense: Present, person: Sg2, form: "cabes" }
  , { infinitive: "caber", tense: Present, person: Sg3, form: "cabe" }
  , { infinitive: "caber", tense: Present, person: Pl1, form: "cabemos" }
  , { infinitive: "caber", tense: Present, person: Pl3, form: "caben" }
  , { infinitive: "caber", tense: Preterite, person: Sg1, form: "cupe" }
  , { infinitive: "caber", tense: Preterite, person: Sg2, form: "cupiste" }
  , { infinitive: "caber", tense: Preterite, person: Sg3, form: "cupo" }
  , { infinitive: "caber", tense: Preterite, person: Pl1, form: "cupimos" }
  , { infinitive: "caber", tense: Preterite, person: Pl3, form: "cupieron" }
  , { infinitive: "caber", tense: Imperfect, person: Sg1, form: "cabía" }
  , { infinitive: "caber", tense: Imperfect, person: Sg2, form: "cabías" }
  , { infinitive: "caber", tense: Imperfect, person: Sg3, form: "cabía" }
  , { infinitive: "caber", tense: Imperfect, person: Pl1, form: "cabíamos" }
  , { infinitive: "caber", tense: Imperfect, person: Pl3, form: "cabían" }
  , { infinitive: "caber", tense: Subjunctive, person: Sg1, form: "quepa" }
  , { infinitive: "caber", tense: Subjunctive, person: Sg2, form: "quepas" }
  , { infinitive: "caber", tense: Subjunctive, person: Sg3, form: "quepa" }
  , { infinitive: "caber", tense: Subjunctive, person: Pl1, form: "quepamos" }
  , { infinitive: "caber", tense: Subjunctive, person: Pl3, form: "quepan" }
  , { infinitive: "valer", tense: Present, person: Sg1, form: "valgo" }
  , { infinitive: "valer", tense: Present, person: Sg2, form: "vales" }
  , { infinitive: "valer", tense: Present, person: Sg3, form: "vale" }
  , { infinitive: "valer", tense: Present, person: Pl1, form: "valemos" }
  , { infinitive: "valer", tense: Present, person: Pl3, form: "valen" }
  , { infinitive: "valer", tense: Preterite, person: Sg1, form: "valí" }
  , { infinitive: "valer", tense: Preterite, person: Sg2, form: "valiste" }
  , { infinitive: "valer", tense: Preterite, person: Sg3, form: "valió" }
  , { infinitive: "valer", tense: Preterite, person: Pl1, form: "valimos" }
  , { infinitive: "valer", tense: Preterite, person: Pl3, form: "valieron" }
  , { infinitive: "valer", tense: Imperfect, person: Sg1, form: "valía" }
  , { infinitive: "valer", tense: Imperfect, person: Sg2, form: "valías" }
  , { infinitive: "valer", tense: Imperfect, person: Sg3, form: "valía" }
  , { infinitive: "valer", tense: Imperfect, person: Pl1, form: "valíamos" }
  , { infinitive: "valer", tense: Imperfect, person: Pl3, form: "valían" }
  , { infinitive: "valer", tense: Subjunctive, person: Sg1, form: "valga" }
  , { infinitive: "valer", tense: Subjunctive, person: Sg2, form: "valgas" }
  , { infinitive: "valer", tense: Subjunctive, person: Sg3, form: "valga" }
  , { infinitive: "valer", tense: Subjunctive, person: Pl1, form: "valgamos" }
  , { infinitive: "valer", tense: Subjunctive, person: Pl3, form: "valgan" }
  , { infinitive: "oír", tense: Present, person: Sg1, form: "oigo" }
  , { infinitive: "oír", tense: Present, person: Sg2, form: "oyes" }
  , { infinitive: "oír", tense: Present, person: Sg3, form: "oye" }
  , { infinitive: "oír", tense: Present, person: Pl1, form: "oímos" }
  , { infinitive: "oír", tense: Present, person: Pl3, form: "oyen" }
  , { infinitive: "oír", tense: Preterite, person: Sg1, form: "oí" }
  , { infinitive: "oír", tense: Preterite, person: Sg2, form: "oíste" }
  , { infinitive: "oír", tense: Preterite, person: Sg3, form: "oyó" }
  , { infinitive: "oír", tense: Preterite, person: Pl1, form: "oímos" }
  , { infinitive: "oír", tense: Preterite, person: Pl3, form: "oyeron" }
  , { infinitive: "oír", tense: Imperfect, person: Sg1, form: "oía" }
  , { infinitive: "oír", tense: Imperfect, person: Sg2, form: "oías" }
  , { infinitive: "oír", tense: Imperfect, person: Sg3, form: "oía" }
  , { infinitive: "oír", tense: Imperfect, person: Pl1, form: "oíamos" }
  , { infinitive: "oír", tense: Imperfect, person: Pl3, form: "oían" }
  , { infinitive: "oír", tense: Subjunctive, person: Sg1, form: "oiga" }
  , { infinitive: "oír", tense: Subjunctive, person: Sg2, form: "oigas" }
  , { infinitive: "oír", tense: Subjunctive, person: Sg3, form: "oiga" }
  , { infinitive: "oír", tense: Subjunctive, person: Pl1, form: "oigamos" }
  , { infinitive: "oír", tense: Subjunctive, person: Pl3, form: "oigan" }
  , { infinitive: "conducir", tense: Present, person: Sg1, form: "conduzco" }
  , { infinitive: "conducir", tense: Present, person: Sg2, form: "conduces" }
  , { infinitive: "conducir", tense: Present, person: Sg3, form: "conduce" }
  , { infinitive: "conducir", tense: Present, person: Pl1, form: "conducimos" }
  , { infinitive: "conducir", tense: Present, person: Pl3, form: "conducen" }
  , { infinitive: "conducir", tense: Preterite, person: Sg1, form: "conduje" }
  , { infinitive: "conducir", tense: Preterite, person: Sg2, form: "condujiste" }
  , { infinitive: "conducir", tense: Preterite, person: Sg3, form: "condujo" }
  , { infinitive: "conducir", tense: Preterite, person: Pl1, form: "condujimos" }
  , { infinitive: "conducir", tense: Preterite, person: Pl3, form: "condujeron" }
  , { infinitive: "conducir", tense: Imperfect, person: Sg1, form: "conducía" }
  , { infinitive: "conducir", tense: Imperfect, person: Sg2, form: "conducías" }
  , { infinitive: "conducir", tense: Imperfect, person: Sg3, form: "conducía" }
  , { infinitive: "conducir", tense: Imperfect, person: Pl1, form: "conducíamos" }
  , { infinitive: "conducir", tense: Imperfect, person: Pl3, form: "conducían" }
  , { infinitive: "conducir", tense: Subjunctive, person: Sg1, form: "conduzca" }
  , { infinitive: "conducir", tense: Subjunctive, person: Sg2, form: "conduzcas" }
  , { infinitive: "conducir", tense: Subjunctive, person: Sg3, form: "conduzca" }
  , { infinitive: "conducir", tense: Subjunctive, person: Pl1, form: "conduzcamos" }
  , { infinitive: "conducir", tense: Subjunctive, person: Pl3, form: "conduzcan" }
  , { infinitive: "pensar", tense: Present, person: Sg1, form: "pienso" }
  , { infinitive: "pensar", tense: Present, person: Sg2, form: "piensas" }
  , { infinitive: "pensar", tense: Present, person: Sg3, form: "piensa" }
  , { infinitive: "pensar", tense: Present, person: Pl1, form: "pensamos" }
  , { infinitive: "pensar", tense: Present, person: Pl3, form: "piensan" }
  , { infinitive: "pensar", tense: Preterite, person: Sg1, form: "pensé" }
  , { infinitive: "pensar", tense: Preterite, person: Sg2, form: "pensaste" }
  , { infinitive: "pensar", tense: Preterite, person: Sg3, form: "pensó" }
  , { infinitive: "pensar", tense: Preterite, person: Pl1, form: "pensamos" }
  , { infinitive: "pensar", tense: Preterite, person: Pl3, form: "pensaron" }
  , { infinitive: "pensar", tense: Imperfect, person: Sg1, form: "pensaba" }
  , { infinitive: "pensar", tense: Imperfect, person: Sg2, form: "pensabas" }
  , { infinitive: "pensar", tense: Imperfect, person: Sg3, form: "pensaba" }
  , { infinitive: "pensar", tense: Imperfect, person: Pl1, form: "pensábamos" }
  , { infinitive: "pensar", tense: Imperfect, person: Pl3, form: "pensaban" }
  , { infinitive: "pensar", tense: Subjunctive, person: Sg1, form: "piense" }
  , { infinitive: "pensar", tense: Subjunctive, person: Sg2, form: "pienses" }
  , { infinitive: "pensar", tense: Subjunctive, person: Sg3, form: "piense" }
  , { infinitive: "pensar", tense: Subjunctive, person: Pl1, form: "pensemos" }
  , { infinitive: "pensar", tense: Subjunctive, person: Pl3, form: "piensen" }
  , { infinitive: "volver", tense: Present, person: Sg1, form: "vuelvo" }
  , { infinitive: "volver", tense: Present, person: Sg2, form: "vuelves" }
  , { infinitive: "volver", tense: Present, person: Sg3, form: "vuelve" }
  , { infinitive: "volver", tense: Present, person: Pl1, form: "volvemos" }
  , { infinitive: "volver", tense: Present, person: Pl3, form: "vuelven" }
  , { infinitive: "volver", tense: Preterite, person: Sg1, form: "volví" }
  , { infinitive: "volver", tense: Preterite, person: Sg2, form: "volviste" }
  , { infinitive: "volver", tense: Preterite, person: Sg3, form: "volvió" }
  , { infinitive: "volver", tense: Preterite, person: Pl1, form: "volvimos" }
  , { infinitive: "volver", tense: Preterite, person: Pl3, form: "volvieron" }
  , { infinitive: "volver", tense: Imperfect, person: Sg1, form: "volvía" }
  , { infinitive: "volver", tense: Imperfect, person: Sg2, form: "volvías" }
  , { infinitive: "volver", tense: Imperfect, person: Sg3, form: "volvía" }
  , { infinitive: "volver", tense: Imperfect, person: Pl1, form: "volvíamos" }
  , { infinitive: "volver", tense: Imperfect, person: Pl3, form: "volvían" }
  , { infinitive: "volver", tense: Subjunctive, person: Sg1, form: "vuelva" }
  , { infinitive: "volver", tense: Subjunctive, person: Sg2, form: "vuelvas" }
  , { infinitive: "volver", tense: Subjunctive, person: Sg3, form: "vuelva" }
  , { infinitive: "volver", tense: Subjunctive, person: Pl1, form: "volvamos" }
  , { infinitive: "volver", tense: Subjunctive, person: Pl3, form: "vuelvan" }
  , { infinitive: "pedir", tense: Present, person: Sg1, form: "pido" }
  , { infinitive: "pedir", tense: Present, person: Sg2, form: "pides" }
  , { infinitive: "pedir", tense: Present, person: Sg3, form: "pide" }
  , { infinitive: "pedir", tense: Present, person: Pl1, form: "pedimos" }
  , { infinitive: "pedir", tense: Present, person: Pl3, form: "piden" }
  , { infinitive: "pedir", tense: Preterite, person: Sg1, form: "pedí" }
  , { infinitive: "pedir", tense: Preterite, person: Sg2, form: "pediste" }
  , { infinitive: "pedir", tense: Preterite, person: Sg3, form: "pidió" }
  , { infinitive: "pedir", tense: Preterite, person: Pl1, form: "pedimos" }
  , { infinitive: "pedir", tense: Preterite, person: Pl3, form: "pidieron" }
  , { infinitive: "pedir", tense: Imperfect, person: Sg1, form: "pedía" }
  , { infinitive: "pedir", tense: Imperfect, person: Sg2, form: "pedías" }
  , { infinitive: "pedir", tense: Imperfect, person: Sg3, form: "pedía" }
  , { infinitive: "pedir", tense: Imperfect, person: Pl1, form: "pedíamos" }
  , { infinitive: "pedir", tense: Imperfect, person: Pl3, form: "pedían" }
  , { infinitive: "pedir", tense: Subjunctive, person: Sg1, form: "pida" }
  , { infinitive: "pedir", tense: Subjunctive, person: Sg2, form: "pidas" }
  , { infinitive: "pedir", tense: Subjunctive, person: Sg3, form: "pida" }
  , { infinitive: "pedir", tense: Subjunctive, person: Pl1, form: "pidamos" }
  , { infinitive: "pedir", tense: Subjunctive, person: Pl3, form: "pidan" }
  , { infinitive: "dormir", tense: Present, person: Sg1, form: "duermo" }
  , { infinitive: "dormir", tense: Present, person: Sg2, form: "duermes" }
  , { infinitive: "dormir", tense: Present, person: Sg3, form: "duerme" }
  , { infinitive: "dormir", tense: Present, person: Pl1, form: "dormimos" }
  , { infinitive: "dormir", tense: Present, person: Pl3, form: "duermen" }
  , { infinitive: "dormir", tense: Preterite, person: Sg1, form: "dormí" }
  , { infinitive: "dormir", tense: Preterite, person: Sg2, form: "dormiste" }
  , { infinitive: "dormir", tense: Preterite, person: Sg3, form: "durmió" }
  , { infinitive: "dormir", tense: Preterite, person: Pl1, form: "dormimos" }
  , { infinitive: "dormir", tense: Preterite, person: Pl3, form: "durmieron" }
  , { infinitive: "dormir", tense: Imperfect, person: Sg1, form: "dormía" }
  , { infinitive: "dormir", tense: Imperfect, person: Sg2, form: "dormías" }
  , { infinitive: "dormir", tense: Imperfect, person: Sg3, form: "dormía" }
  , { infinitive: "dormir", tense: Imperfect, person: Pl1, form: "dormíamos" }
  , { infinitive: "dormir", tense: Imperfect, person: Pl3, form: "dormían" }
  , { infinitive: "dormir", tense: Subjunctive, person: Sg1, form: "duerma" }
  , { infinitive: "dormir", tense: Subjunctive, person: Sg2, form: "duermas" }
  , { infinitive: "dormir", tense: Subjunctive, person: Sg3, form: "duerma" }
  , { infinitive: "dormir", tense: Subjunctive, person: Pl1, form: "durmamos" }
  , { infinitive: "dormir", tense: Subjunctive, person: Pl3, form: "duerman" }
  , { infinitive: "jugar", tense: Present, person: Sg1, form: "juego" }
  , { infinitive: "jugar", tense: Present, person: Sg2, form: "juegas" }
  , { infinitive: "jugar", tense: Present, person: Sg3, form: "juega" }
  , { infinitive: "jugar", tense: Present, person: Pl1, form: "jugamos" }
  , { infinitive: "jugar", tense: Present, person: Pl3, form: "juegan" }
  , { infinitive: "jugar", tense: Preterite, person: Sg1, form: "jugué" }
  , { infinitive: "jugar", tense: Preterite, person: Sg2, form: "jugaste" }
  , { infinitive: "jugar", tense: Preterite, person: Sg3, form: "jugó" }
  , { infinitive: "jugar", tense: Preterite, person: Pl1, form: "jugamos" }
  , { infinitive: "jugar", tense: Preterite, person: Pl3, form: "jugaron" }
  , { infinitive: "jugar", tense: Imperfect, person: Sg1, form: "jugaba" }
  , { infinitive: "jugar", tense: Imperfect, person: Sg2, form: "jugabas" }
  , { infinitive: "jugar", tense: Imperfect, person: Sg3, form: "jugaba" }
  , { infinitive: "jugar", tense: Imperfect, person: Pl1, form: "jugábamos" }
  , { infinitive: "jugar", tense: Imperfect, person: Pl3, form: "jugaban" }
  , { infinitive: "jugar", tense: Subjunctive, person: Sg1, form: "juegue" }
  , { infinitive: "jugar", tense: Subjunctive, person: Sg2, form: "juegues" }
  , { infinitive: "jugar", tense: Subjunctive, person: Sg3, form: "juegue" }
  , { infinitive: "jugar", tense: Subjunctive, person: Pl1, form: "juguemos" }
  , { infinitive: "jugar", tense: Subjunctive, person: Pl3, form: "jueguen" }
  , { infinitive: "llegar", tense: Present, person: Sg1, form: "llego" }
  , { infinitive: "llegar", tense: Present, person: Sg2, form: "llegas" }
  , { infinitive: "llegar", tense: Present, person: Sg3, form: "llega" }
  , { infinitive: "llegar", tense: Present, person: Pl1, form: "llegamos" }
  , { infinitive: "llegar", tense: Present, person: Pl3, form: "llegan" }
  , { infinitive: "llegar", tense: Preterite, person: Sg1, form: "llegué" }
  , { infinitive: "llegar", tense: Preterite, person: Sg2, form: "llegaste" }
  , { infinitive: "llegar", tense: Preterite, person: Sg3, form: "llegó" }
  , { infinitive: "llegar", tense: Preterite, person: Pl1, form: "llegamos" }
  , { infinitive: "llegar", tense: Preterite, person: Pl3, form: "llegaron" }
  , { infinitive: "llegar", tense: Imperfect, person: Sg1, form: "llegaba" }
  , { infinitive: "llegar", tense: Imperfect, person: Sg2, form: "llegabas" }
  , { infinitive: "llegar", tense: Imperfect, person: Sg3, form: "llegaba" }
  , { infinitive: "llegar", tense: Imperfect, person: Pl1, form: "llegábamos" }
  , { infinitive: "llegar", tense: Imperfect, person: Pl3, form: "llegaban" }
  , { infinitive: "llegar", tense: Subjunctive, person: Sg1, form: "llegue" }
  , { infinitive: "llegar", tense: Subjunctive, person: Sg2, form: "llegues" }
  , { infinitive: "llegar", tense: Subjunctive, person: Sg3, form: "llegue" }
  , { infinitive: "llegar", tense: Subjunctive, person: Pl1, form: "lleguemos" }
  , { infinitive: "llegar", tense: Subjunctive, person: Pl3, form: "lleguen" }
  , { infinitive: "buscar", tense: Present, person: Sg1, form: "busco" }
  , { infinitive: "buscar", tense: Present, person: Sg2, form: "buscas" }
  , { infinitive: "buscar", tense: Present, person: Sg3, form: "busca" }
  , { infinitive: "buscar", tense: Present, person: Pl1, form: "buscamos" }
  , { infinitive: "buscar", tense: Present, person: Pl3, form: "buscan" }
  , { infinitive: "buscar", tense: Preterite, person: Sg1, form: "busqué" }
  , { infinitive: "buscar", tense: Preterite, person: Sg2, form: "buscaste" }
  , { infinitive: "buscar", tense: Preterite, person: Sg3, form: "buscó" }
  , { infinitive: "buscar", tense: Preterite, person: Pl1, form: "buscamos" }
  , { infinitive: "buscar", tense: Preterite, person: Pl3, form: "buscaron" }
  , { infinitive: "buscar", tense: Imperfect, person: Sg1, form: "buscaba" }
  , { infinitive: "buscar", tense: Imperfect, person: Sg2, form: "buscabas" }
  , { infinitive: "buscar", tense: Imperfect, person: Sg3, form: "buscaba" }
  , { infinitive: "buscar", tense: Imperfect, person: Pl1, form: "buscábamos" }
  , { infinitive: "buscar", tense: Imperfect, person: Pl3, form: "buscaban" }
  , { infinitive: "buscar", tense: Subjunctive, person: Sg1, form: "busque" }
  , { infinitive: "buscar", tense: Subjunctive, person: Sg2, form: "busques" }
  , { infinitive: "buscar", tense: Subjunctive, person: Sg3, form: "busque" }
  , { infinitive: "buscar", tense: Subjunctive, person: Pl1, form: "busquemos" }
  , { infinitive: "buscar", tense: Subjunctive, person: Pl3, form: "busquen" }
  , { infinitive: "empezar", tense: Present, person: Sg1, form: "empiezo" }
  , { infinitive: "empezar", tense: Present, person: Sg2, form: "empiezas" }
  , { infinitive: "empezar", tense: Present, person: Sg3, form: "empieza" }
  , { infinitive: "empezar", tense: Present, person: Pl1, form: "empezamos" }
  , { infinitive: "empezar", tense: Present, person: Pl3, form: "empiezan" }
  , { infinitive: "empezar", tense: Preterite, person: Sg1, form: "empecé" }
  , { infinitive: "empezar", tense: Preterite, person: Sg2, form: "empezaste" }
  , { infinitive: "empezar", tense: Preterite, person: Sg3, form: "empezó" }
  , { infinitive: "empezar", tense: Preterite, person: Pl1, form: "empezamos" }
  , { infinitive: "empezar", tense: Preterite, person: Pl3, form: "empezaron" }
  , { infinitive: "empezar", tense: Imperfect, person: Sg1, form: "empezaba" }
  , { infinitive: "empezar", tense: Imperfect, person: Sg2, form: "empezabas" }
  , { infinitive: "empezar", tense: Imperfect, person: Sg3, form: "empezaba" }
  , { infinitive: "empezar", tense: Imperfect, person: Pl1, form: "empezábamos" }
  , { infinitive: "empezar", tense: Imperfect, person: Pl3, form: "empezaban" }
  , { infinitive: "empezar", tense: Subjunctive, person: Sg1, form: "empiece" }
  , { infinitive: "empezar", tense: Subjunctive, person: Sg2, form: "empieces" }
  , { infinitive: "empezar", tense: Subjunctive, person: Sg3, form: "empiece" }
  , { infinitive: "empezar", tense: Subjunctive, person: Pl1, form: "empecemos" }
  , { infinitive: "empezar", tense: Subjunctive, person: Pl3, form: "empiecen" }
  , { infinitive: "andar", tense: Present, person: Sg1, form: "ando" }
  , { infinitive: "andar", tense: Present, person: Sg2, form: "andas" }
  , { infinitive: "andar", tense: Present, person: Sg3, form: "anda" }
  , { infinitive: "andar", tense: Present, person: Pl1, form: "andamos" }
  , { infinitive: "andar", tense: Present, person: Pl3, form: "andan" }
  , { infinitive: "andar", tense: Preterite, person: Sg1, form: "anduve" }
  , { infinitive: "andar", tense: Preterite, person: Sg2, form: "anduviste" }
  , { infinitive: "andar", tense: Preterite, person: Sg3, form: "anduvo" }
  , { infinitive: "andar", tense: Preterite, person: Pl1, form: "anduvimos" }
  , { infinitive: "andar", tense: Preterite, person: Pl3, form: "anduvieron" }
  , { infinitive: "andar", tense: Imperfect, person: Sg1, form: "andaba" }
  , { infinitive: "andar", tense: Imperfect, person: Sg2, form: "andabas" }
  , { infinitive: "andar", tense: Imperfect, person: Sg3, form: "andaba" }
  , { infinitive: "andar", tense: Imperfect, person: Pl1, form: "andábamos" }
  , { infinitive: "andar", tense: Imperfect, person: Pl3, form: "andaban" }
  , { infinitive: "andar", tense: Subjunctive, person: Sg1, form: "ande" }
  , { infinitive: "andar", tense: Subjunctive, person: Sg2, form: "andes" }
  , { infinitive: "andar", tense: Subjunctive, person: Sg3, form: "ande" }
  , { infinitive: "andar", tense: Subjunctive, person: Pl1, form: "andemos" }
  , { infinitive: "andar", tense: Subjunctive, person: Pl3, form: "anden" }
  , { infinitive: "caer", tense: Present, person: Sg1, form: "caigo" }
  , { infinitive: "caer", tense: Present, person: Sg2, form: "caes" }
  , { infinitive: "caer", tense: Present, person: Sg3, form: "cae" }
  , { infinitive: "caer", tense: Present, person: Pl1, form: "caemos" }
  , { infinitive: "caer", tense: Present, person: Pl3, form: "caen" }
  , { infinitive: "caer", tense: Preterite, person: Sg1, form: "caí" }
  , { infinitive: "caer", tense: Preterite, person: Sg2, form: "caíste" }
  , { infinitive: "caer", tense: Preterite, person: Sg3, form: "cayó" }
  , { infinitive: "caer", tense: Preterite, person: Pl1, form: "caímos" }
  , { infinitive: "caer", tense: Preterite, person: Pl3, form: "cayeron" }
  , { infinitive: "caer", tense: Imperfect, person: Sg1, form: "caía" }
  , { infinitive: "caer", tense: Imperfect, person: Sg2, form: "caías" }
  , { infinitive: "caer", tense: Imperfect, person: Sg3, form: "caía" }
  , { infinitive: "caer", tense: Imperfect, person: Pl1, form: "caíamos" }
  , { infinitive: "caer", tense: Imperfect, person: Pl3, form: "caían" }
  , { infinitive: "caer", tense: Subjunctive, person: Sg1, form: "caiga" }
  , { infinitive: "caer", tense: Subjunctive, person: Sg2, form: "caigas" }
  , { infinitive: "caer", tense: Subjunctive, person: Sg3, form: "caiga" }
  , { infinitive: "caer", tense: Subjunctive, person: Pl1, form: "caigamos" }
  , { infinitive: "caer", tense: Subjunctive, person: Pl3, form: "caigan" }
  , { infinitive: "conocer", tense: Present, person: Sg1, form: "conozco" }
  , { infinitive: "conocer", tense: Present, person: Sg2, form: "conoces" }
  , { infinitive: "conocer", tense: Present, person: Sg3, form: "conoce" }
  , { infinitive: "conocer", tense: Present, person: Pl1, form: "conocemos" }
  , { infinitive: "conocer", tense: Present, person: Pl3, form: "conocen" }
  , { infinitive: "conocer", tense: Preterite, person: Sg1, form: "conocí" }
  , { infinitive: "conocer", tense: Preterite, person: Sg2, form: "conociste" }
  , { infinitive: "conocer", tense: Preterite, person: Sg3, form: "conoció" }
  , { infinitive: "conocer", tense: Preterite, person: Pl1, form: "conocimos" }
  , { infinitive: "conocer", tense: Preterite, person: Pl3, form: "conocieron" }
  , { infinitive: "conocer", tense: Imperfect, person: Sg1, form: "conocía" }
  , { infinitive: "conocer", tense: Imperfect, person: Sg2, form: "conocías" }
  , { infinitive: "conocer", tense: Imperfect, person: Sg3, form: "conocía" }
  , { infinitive: "conocer", tense: Imperfect, person: Pl1, form: "conocíamos" }
  , { infinitive: "conocer", tense: Imperfect, person: Pl3, form: "conocían" }
  , { infinitive: "conocer", tense: Subjunctive, person: Sg1, form: "conozca" }
  , { infinitive: "conocer", tense: Subjunctive, person: Sg2, form: "conozcas" }
  , { infinitive: "conocer", tense: Subjunctive, person: Sg3, form: "conozca" }
  , { infinitive: "conocer", tense: Subjunctive, person: Pl1, form: "conozcamos" }
  , { infinitive: "conocer", tense: Subjunctive, person: Pl3, form: "conozcan" }
  , { infinitive: "leer", tense: Present, person: Sg1, form: "leo" }
  , { infinitive: "leer", tense: Present, person: Sg2, form: "lees" }
  , { infinitive: "leer", tense: Present, person: Sg3, form: "lee" }
  , { infinitive: "leer", tense: Present, person: Pl1, form: "leemos" }
  , { infinitive: "leer", tense: Present, person: Pl3, form: "leen" }
  , { infinitive: "leer", tense: Preterite, person: Sg1, form: "leí" }
  , { infinitive: "leer", tense: Preterite, person: Sg2, form: "leíste" }
  , { infinitive: "leer", tense: Preterite, person: Sg3, form: "leyó" }
  , { infinitive: "leer", tense: Preterite, person: Pl1, form: "leímos" }
  , { infinitive: "leer", tense: Preterite, person: Pl3, form: "leyeron" }
  , { infinitive: "leer", tense: Imperfect, person: Sg1, form: "leía" }
  , { infinitive: "leer", tense: Imperfect, person: Sg2, form: "leías" }
  , { infinitive: "leer", tense: Imperfect, person: Sg3, form: "leía" }
  , { infinitive: "leer", tense: Imperfect, person: Pl1, form: "leíamos" }
  , { infinitive: "leer", tense: Imperfect, person: Pl3, form: "leían" }
  , { infinitive: "leer", tense: Subjunctive, person: Sg1, form: "lea" }
  , { infinitive: "leer", tense: Subjunctive, person: Sg2, form: "leas" }
  , { infinitive: "leer", tense: Subjunctive, person: Sg3, form: "lea" }
  , { infinitive: "leer", tense: Subjunctive, person: Pl1, form: "leamos" }
  , { infinitive: "leer", tense: Subjunctive, person: Pl3, form: "lean" }
  , { infinitive: "construir", tense: Present, person: Sg1, form: "construyo" }
  , { infinitive: "construir", tense: Present, person: Sg2, form: "construyes" }
  , { infinitive: "construir", tense: Present, person: Sg3, form: "construye" }
  , { infinitive: "construir", tense: Present, person: Pl1, form: "construimos" }
  , { infinitive: "construir", tense: Present, person: Pl3, form: "construyen" }
  , { infinitive: "construir", tense: Preterite, person: Sg1, form: "construí" }
  , { infinitive: "construir", tense: Preterite, person: Sg2, form: "construiste" }
  , { infinitive: "construir", tense: Preterite, person: Sg3, form: "construyó" }
  , { infinitive: "construir", tense: Preterite, person: Pl1, form: "construimos" }
  , { infinitive: "construir", tense: Preterite, person: Pl3, form: "construyeron" }
  , { infinitive: "construir", tense: Imperfect, person: Sg1, form: "construía" }
  , { infinitive: "construir", tense: Imperfect, person: Sg2, form: "construías" }
  , { infinitive: "construir", tense: Imperfect, person: Sg3, form: "construía" }
  , { infinitive: "construir", tense: Imperfect, person: Pl1, form: "construíamos" }
  , { infinitive: "construir", tense: Imperfect, person: Pl3, form: "construían" }
  , { infinitive: "construir", tense: Subjunctive, person: Sg1, form: "construya" }
  , { infinitive: "construir", tense: Subjunctive, person: Sg2, form: "construyas" }
  , { infinitive: "construir", tense: Subjunctive, person: Sg3, form: "construya" }
  , { infinitive: "construir", tense: Subjunctive, person: Pl1, form: "construyamos" }
  , { infinitive: "construir", tense: Subjunctive, person: Pl3, form: "construyan" }
  , { infinitive: "reír", tense: Present, person: Sg1, form: "río" }
  , { infinitive: "reír", tense: Present, person: Sg2, form: "ríes" }
  , { infinitive: "reír", tense: Present, person: Sg3, form: "ríe" }
  , { infinitive: "reír", tense: Present, person: Pl1, form: "reímos" }
  , { infinitive: "reír", tense: Present, person: Pl3, form: "ríen" }
  , { infinitive: "reír", tense: Preterite, person: Sg1, form: "reí" }
  , { infinitive: "reír", tense: Preterite, person: Sg2, form: "reíste" }
  , { infinitive: "reír", tense: Preterite, person: Sg3, form: "rio" }
  , { infinitive: "reír", tense: Preterite, person: Pl1, form: "reímos" }
  , { infinitive: "reír", tense: Preterite, person: Pl3, form: "rieron" }
  , { infinitive: "reír", tense: Imperfect, person: Sg1, form: "reía" }
  , { infinitive: "reír", tense: Imperfect, person: Sg2, form: "reías" }
  , { infinitive: "reír", tense: Imperfect, person: Sg3, form: "reía" }
  , { infinitive: "reír", tense: Imperfect, person: Pl1, form: "reíamos" }
  , { infinitive: "reír", tense: Imperfect, person: Pl3, form: "reían" }
  , { infinitive: "reír", tense: Subjunctive, person: Sg1, form: "ría" }
  , { infinitive: "reír", tense: Subjunctive, person: Sg2, form: "rías" }
  , { infinitive: "reír", tense: Subjunctive, person: Sg3, form: "ría" }
  , { infinitive: "reír", tense: Subjunctive, person: Pl1, form: "riamos" }
  , { infinitive: "reír", tense: Subjunctive, person: Pl3, form: "rían" }
  , { infinitive: "seguir", tense: Present, person: Sg1, form: "sigo" }
  , { infinitive: "seguir", tense: Present, person: Sg2, form: "sigues" }
  , { infinitive: "seguir", tense: Present, person: Sg3, form: "sigue" }
  , { infinitive: "seguir", tense: Present, person: Pl1, form: "seguimos" }
  , { infinitive: "seguir", tense: Present, person: Pl3, form: "siguen" }
  , { infinitive: "seguir", tense: Preterite, person: Sg1, form: "seguí" }
  , { infinitive: "seguir", tense: Preterite, person: Sg2, form: "seguiste" }
  , { infinitive: "seguir", tense: Preterite, person: Sg3, form: "siguió" }
  , { infinitive: "seguir", tense: Preterite, person: Pl1, form: "seguimos" }
  , { infinitive: "seguir", tense: Preterite, person: Pl3, form: "siguieron" }
  , { infinitive: "seguir", tense: Imperfect, person: Sg1, form: "seguía" }
  , { infinitive: "seguir", tense: Imperfect, person: Sg2, form: "seguías" }
  , { infinitive: "seguir", tense: Imperfect, person: Sg3, form: "seguía" }
  , { infinitive: "seguir", tense: Imperfect, person: Pl1, form: "seguíamos" }
  , { infinitive: "seguir", tense: Imperfect, person: Pl3, form: "seguían" }
  , { infinitive: "seguir", tense: Subjunctive, person: Sg1, form: "siga" }
  , { infinitive: "seguir", tense: Subjunctive, person: Sg2, form: "sigas" }
  , { infinitive: "seguir", tense: Subjunctive, person: Sg3, form: "siga" }
  , { infinitive: "seguir", tense: Subjunctive, person: Pl1, form: "sigamos" }
  , { infinitive: "seguir", tense: Subjunctive, person: Pl3, form: "sigan" }
  , { infinitive: "sentir", tense: Present, person: Sg1, form: "siento" }
  , { infinitive: "sentir", tense: Present, person: Sg2, form: "sientes" }
  , { infinitive: "sentir", tense: Present, person: Sg3, form: "siente" }
  , { infinitive: "sentir", tense: Present, person: Pl1, form: "sentimos" }
  , { infinitive: "sentir", tense: Present, person: Pl3, form: "sienten" }
  , { infinitive: "sentir", tense: Preterite, person: Sg1, form: "sentí" }
  , { infinitive: "sentir", tense: Preterite, person: Sg2, form: "sentiste" }
  , { infinitive: "sentir", tense: Preterite, person: Sg3, form: "sintió" }
  , { infinitive: "sentir", tense: Preterite, person: Pl1, form: "sentimos" }
  , { infinitive: "sentir", tense: Preterite, person: Pl3, form: "sintieron" }
  , { infinitive: "sentir", tense: Imperfect, person: Sg1, form: "sentía" }
  , { infinitive: "sentir", tense: Imperfect, person: Sg2, form: "sentías" }
  , { infinitive: "sentir", tense: Imperfect, person: Sg3, form: "sentía" }
  , { infinitive: "sentir", tense: Imperfect, person: Pl1, form: "sentíamos" }
  , { infinitive: "sentir", tense: Imperfect, person: Pl3, form: "sentían" }
  , { infinitive: "sentir", tense: Subjunctive, person: Sg1, form: "sienta" }
  , { infinitive: "sentir", tense: Subjunctive, person: Sg2, form: "sientas" }
  , { infinitive: "sentir", tense: Subjunctive, person: Sg3, form: "sienta" }
  , { infinitive: "sentir", tense: Subjunctive, person: Pl1, form: "sintamos" }
  , { infinitive: "sentir", tense: Subjunctive, person: Pl3, form: "sientan" }
  , { infinitive: "morir", tense: Present, person: Sg1, form: "muero" }
  , { infinitive: "morir", tense: Present, person: Sg2, form: "mueres" }
  , { infinitive: "morir", tense: Present, person: Sg3, form: "muere" }
  , { infinitive: "morir", tense: Present, person: Pl1, form: "morimos" }
  , { infinitive: "morir", tense: Present, person: Pl3, form: "mueren" }
  , { infinitive: "morir", tense: Preterite, person: Sg1, form: "morí" }
  , { infinitive: "morir", tense: Preterite, person: Sg2, form: "moriste" }
  , { infinitive: "morir", tense: Preterite, person: Sg3, form: "murió" }
  , { infinitive: "morir", tense: Preterite, person: Pl1, form: "morimos" }
  , { infinitive: "morir", tense: Preterite, person: Pl3, form: "murieron" }
  , { infinitive: "morir", tense: Imperfect, person: Sg1, form: "moría" }
  , { infinitive: "morir", tense: Imperfect, person: Sg2, form: "morías" }
  , { infinitive: "morir", tense: Imperfect, person: Sg3, form: "moría" }
  , { infinitive: "morir", tense: Imperfect, person: Pl1, form: "moríamos" }
  , { infinitive: "morir", tense: Imperfect, person: Pl3, form: "morían" }
  , { infinitive: "morir", tense: Subjunctive, person: Sg1, form: "muera" }
  , { infinitive: "morir", tense: Subjunctive, person: Sg2, form: "mueras" }
  , { infinitive: "morir", tense: Subjunctive, person: Sg3, form: "muera" }
  , { infinitive: "morir", tense: Subjunctive, person: Pl1, form: "muramos" }
  , { infinitive: "morir", tense: Subjunctive, person: Pl3, form: "mueran" }
  , { infinitive: "oler", tense: Present, person: Sg1, form: "huelo" }
  , { infinitive: "oler", tense: Present, person: Sg2, form: "hueles" }
  , { infinitive: "oler", tense: Present, person: Sg3, form: "huele" }
  , { infinitive: "oler", tense: Present, person: Pl1, form: "olemos" }
  , { infinitive: "oler", tense: Present, person: Pl3, form: "huelen" }
  , { infinitive: "oler", tense: Preterite, person: Sg1, form: "olí" }
  , { infinitive: "oler", tense: Preterite, person: Sg2, form: "oliste" }
  , { infinitive: "oler", tense: Preterite, person: Sg3, form: "olió" }
  , { infinitive: "oler", tense: Preterite, person: Pl1, form: "olimos" }
  , { infinitive: "oler", tense: Preterite, person: Pl3, form: "olieron" }
  , { infinitive: "oler", tense: Imperfect, person: Sg1, form: "olía" }
  , { infinitive: "oler", tense: Imperfect, person: Sg2, form: "olías" }
  , { infinitive: "oler", tense: Imperfect, person: Sg3, form: "olía" }
  , { infinitive: "oler", tense: Imperfect, person: Pl1, form: "olíamos" }
  , { infinitive: "oler", tense: Imperfect, person: Pl3, form: "olían" }
  , { infinitive: "oler", tense: Subjunctive, person: Sg1, form: "huela" }
  , { infinitive: "oler", tense: Subjunctive, person: Sg2, form: "huelas" }
  , { infinitive: "oler", tense: Subjunctive, person: Sg3, form: "huela" }
  , { infinitive: "oler", tense: Subjunctive, person: Pl1, form: "olamos" }
  , { infinitive: "oler", tense: Subjunctive, person: Pl3, form: "huelan" }
  , { infinitive: "elegir", tense: Present, person: Sg1, form: "elijo" }
  , { infinitive: "elegir", tense: Present, person: Sg2, form: "eliges" }
  , { infinitive: "elegir", tense: Present, person: Sg3, form: "elige" }
  , { infinitive: "elegir", tense: Present, person: Pl1, form: "elegimos" }
  , { infinitive: "elegir", tense: Present, person: Pl3, form: "eligen" }
  , { infinitive: "elegir", tense: Preterite, person: Sg1, form: "elegí" }
  , { infinitive: "elegir", tense: Preterite, person: Sg2, form: "elegiste" }
  , { infinitive: "elegir", tense: Preterite, person: Sg3, form: "eligió" }
  , { infinitive: "elegir", tense: Preterite, person: Pl1, form: "elegimos" }
  , { infinitive: "elegir", tense: Preterite, person: Pl3, form: "eligieron" }
  , { infinitive: "elegir", tense: Imperfect, person: Sg1, form: "elegía" }
  , { infinitive: "elegir", tense: Imperfect, person: Sg2, form: "elegías" }
  , { infinitive: "elegir", tense: Imperfect, person: Sg3, form: "elegía" }
  , { infinitive: "elegir", tense: Imperfect, person: Pl1, form: "elegíamos" }
  , { infinitive: "elegir", tense: Imperfect, person: Pl3, form: "elegían" }
  , { infinitive: "elegir", tense: Subjunctive, person: Sg1, form: "elija" }
  , { infinitive: "elegir", tense: Subjunctive, person: Sg2, form: "elijas" }
  , { infinitive: "elegir", tense: Subjunctive, person: Sg3, form: "elija" }
  , { infinitive: "elegir", tense: Subjunctive, person: Pl1, form: "elijamos" }
  , { infinitive: "elegir", tense: Subjunctive, person: Pl3, form: "elijan" }
  ]

-- | Every cell that differs from the regular pattern, and what the pattern
-- | would have given: what `npm run check-verbs` prints. 404 of them.
deviations :: Array Deviation
deviations =
  [ { infinitive: "ser", tense: Present, person: Sg1, regular: "so" }
  , { infinitive: "ser", tense: Present, person: Sg2, regular: "ses" }
  , { infinitive: "ser", tense: Present, person: Sg3, regular: "se" }
  , { infinitive: "ser", tense: Present, person: Pl1, regular: "semos" }
  , { infinitive: "ser", tense: Present, person: Pl3, regular: "sen" }
  , { infinitive: "ser", tense: Preterite, person: Sg1, regular: "si" }
  , { infinitive: "ser", tense: Preterite, person: Sg2, regular: "siste" }
  , { infinitive: "ser", tense: Preterite, person: Sg3, regular: "sio" }
  , { infinitive: "ser", tense: Preterite, person: Pl1, regular: "simos" }
  , { infinitive: "ser", tense: Preterite, person: Pl3, regular: "sieron" }
  , { infinitive: "ser", tense: Imperfect, person: Sg1, regular: "sía" }
  , { infinitive: "ser", tense: Imperfect, person: Sg2, regular: "sías" }
  , { infinitive: "ser", tense: Imperfect, person: Sg3, regular: "sía" }
  , { infinitive: "ser", tense: Imperfect, person: Pl1, regular: "síamos" }
  , { infinitive: "ser", tense: Imperfect, person: Pl3, regular: "sían" }
  , { infinitive: "ser", tense: Subjunctive, person: Sg1, regular: "sa" }
  , { infinitive: "ser", tense: Subjunctive, person: Sg2, regular: "sas" }
  , { infinitive: "ser", tense: Subjunctive, person: Sg3, regular: "sa" }
  , { infinitive: "ser", tense: Subjunctive, person: Pl1, regular: "samos" }
  , { infinitive: "ser", tense: Subjunctive, person: Pl3, regular: "san" }
  , { infinitive: "estar", tense: Present, person: Sg1, regular: "esto" }
  , { infinitive: "estar", tense: Present, person: Sg2, regular: "estas" }
  , { infinitive: "estar", tense: Present, person: Sg3, regular: "esta" }
  , { infinitive: "estar", tense: Present, person: Pl3, regular: "estan" }
  , { infinitive: "estar", tense: Preterite, person: Sg1, regular: "esté" }
  , { infinitive: "estar", tense: Preterite, person: Sg2, regular: "estaste" }
  , { infinitive: "estar", tense: Preterite, person: Sg3, regular: "estó" }
  , { infinitive: "estar", tense: Preterite, person: Pl1, regular: "estamos" }
  , { infinitive: "estar", tense: Preterite, person: Pl3, regular: "estaron" }
  , { infinitive: "estar", tense: Subjunctive, person: Sg1, regular: "este" }
  , { infinitive: "estar", tense: Subjunctive, person: Sg2, regular: "estes" }
  , { infinitive: "estar", tense: Subjunctive, person: Sg3, regular: "este" }
  , { infinitive: "estar", tense: Subjunctive, person: Pl3, regular: "esten" }
  , { infinitive: "ir", tense: Present, person: Sg1, regular: "o" }
  , { infinitive: "ir", tense: Present, person: Sg2, regular: "es" }
  , { infinitive: "ir", tense: Present, person: Sg3, regular: "e" }
  , { infinitive: "ir", tense: Present, person: Pl1, regular: "imos" }
  , { infinitive: "ir", tense: Present, person: Pl3, regular: "en" }
  , { infinitive: "ir", tense: Preterite, person: Sg1, regular: "i" }
  , { infinitive: "ir", tense: Preterite, person: Sg2, regular: "iste" }
  , { infinitive: "ir", tense: Preterite, person: Sg3, regular: "io" }
  , { infinitive: "ir", tense: Preterite, person: Pl1, regular: "imos" }
  , { infinitive: "ir", tense: Preterite, person: Pl3, regular: "ieron" }
  , { infinitive: "ir", tense: Imperfect, person: Sg1, regular: "ía" }
  , { infinitive: "ir", tense: Imperfect, person: Sg2, regular: "ías" }
  , { infinitive: "ir", tense: Imperfect, person: Sg3, regular: "ía" }
  , { infinitive: "ir", tense: Imperfect, person: Pl1, regular: "íamos" }
  , { infinitive: "ir", tense: Imperfect, person: Pl3, regular: "ían" }
  , { infinitive: "ir", tense: Subjunctive, person: Sg1, regular: "a" }
  , { infinitive: "ir", tense: Subjunctive, person: Sg2, regular: "as" }
  , { infinitive: "ir", tense: Subjunctive, person: Sg3, regular: "a" }
  , { infinitive: "ir", tense: Subjunctive, person: Pl1, regular: "amos" }
  , { infinitive: "ir", tense: Subjunctive, person: Pl3, regular: "an" }
  , { infinitive: "tener", tense: Present, person: Sg1, regular: "teno" }
  , { infinitive: "tener", tense: Present, person: Sg2, regular: "tenes" }
  , { infinitive: "tener", tense: Present, person: Sg3, regular: "tene" }
  , { infinitive: "tener", tense: Present, person: Pl3, regular: "tenen" }
  , { infinitive: "tener", tense: Preterite, person: Sg1, regular: "tení" }
  , { infinitive: "tener", tense: Preterite, person: Sg2, regular: "teniste" }
  , { infinitive: "tener", tense: Preterite, person: Sg3, regular: "tenió" }
  , { infinitive: "tener", tense: Preterite, person: Pl1, regular: "tenimos" }
  , { infinitive: "tener", tense: Preterite, person: Pl3, regular: "tenieron" }
  , { infinitive: "tener", tense: Subjunctive, person: Sg1, regular: "tena" }
  , { infinitive: "tener", tense: Subjunctive, person: Sg2, regular: "tenas" }
  , { infinitive: "tener", tense: Subjunctive, person: Sg3, regular: "tena" }
  , { infinitive: "tener", tense: Subjunctive, person: Pl1, regular: "tenamos" }
  , { infinitive: "tener", tense: Subjunctive, person: Pl3, regular: "tenan" }
  , { infinitive: "hacer", tense: Present, person: Sg1, regular: "haco" }
  , { infinitive: "hacer", tense: Preterite, person: Sg1, regular: "hací" }
  , { infinitive: "hacer", tense: Preterite, person: Sg2, regular: "haciste" }
  , { infinitive: "hacer", tense: Preterite, person: Sg3, regular: "hació" }
  , { infinitive: "hacer", tense: Preterite, person: Pl1, regular: "hacimos" }
  , { infinitive: "hacer", tense: Preterite, person: Pl3, regular: "hacieron" }
  , { infinitive: "hacer", tense: Subjunctive, person: Sg1, regular: "haca" }
  , { infinitive: "hacer", tense: Subjunctive, person: Sg2, regular: "hacas" }
  , { infinitive: "hacer", tense: Subjunctive, person: Sg3, regular: "haca" }
  , { infinitive: "hacer", tense: Subjunctive, person: Pl1, regular: "hacamos" }
  , { infinitive: "hacer", tense: Subjunctive, person: Pl3, regular: "hacan" }
  , { infinitive: "poder", tense: Present, person: Sg1, regular: "podo" }
  , { infinitive: "poder", tense: Present, person: Sg2, regular: "podes" }
  , { infinitive: "poder", tense: Present, person: Sg3, regular: "pode" }
  , { infinitive: "poder", tense: Present, person: Pl3, regular: "poden" }
  , { infinitive: "poder", tense: Preterite, person: Sg1, regular: "podí" }
  , { infinitive: "poder", tense: Preterite, person: Sg2, regular: "podiste" }
  , { infinitive: "poder", tense: Preterite, person: Sg3, regular: "podió" }
  , { infinitive: "poder", tense: Preterite, person: Pl1, regular: "podimos" }
  , { infinitive: "poder", tense: Preterite, person: Pl3, regular: "podieron" }
  , { infinitive: "poder", tense: Subjunctive, person: Sg1, regular: "poda" }
  , { infinitive: "poder", tense: Subjunctive, person: Sg2, regular: "podas" }
  , { infinitive: "poder", tense: Subjunctive, person: Sg3, regular: "poda" }
  , { infinitive: "poder", tense: Subjunctive, person: Pl3, regular: "podan" }
  , { infinitive: "decir", tense: Present, person: Sg1, regular: "deco" }
  , { infinitive: "decir", tense: Present, person: Sg2, regular: "deces" }
  , { infinitive: "decir", tense: Present, person: Sg3, regular: "dece" }
  , { infinitive: "decir", tense: Present, person: Pl3, regular: "decen" }
  , { infinitive: "decir", tense: Preterite, person: Sg1, regular: "decí" }
  , { infinitive: "decir", tense: Preterite, person: Sg2, regular: "deciste" }
  , { infinitive: "decir", tense: Preterite, person: Sg3, regular: "deció" }
  , { infinitive: "decir", tense: Preterite, person: Pl1, regular: "decimos" }
  , { infinitive: "decir", tense: Preterite, person: Pl3, regular: "decieron" }
  , { infinitive: "decir", tense: Subjunctive, person: Sg1, regular: "deca" }
  , { infinitive: "decir", tense: Subjunctive, person: Sg2, regular: "decas" }
  , { infinitive: "decir", tense: Subjunctive, person: Sg3, regular: "deca" }
  , { infinitive: "decir", tense: Subjunctive, person: Pl1, regular: "decamos" }
  , { infinitive: "decir", tense: Subjunctive, person: Pl3, regular: "decan" }
  , { infinitive: "poner", tense: Present, person: Sg1, regular: "pono" }
  , { infinitive: "poner", tense: Preterite, person: Sg1, regular: "poní" }
  , { infinitive: "poner", tense: Preterite, person: Sg2, regular: "poniste" }
  , { infinitive: "poner", tense: Preterite, person: Sg3, regular: "ponió" }
  , { infinitive: "poner", tense: Preterite, person: Pl1, regular: "ponimos" }
  , { infinitive: "poner", tense: Preterite, person: Pl3, regular: "ponieron" }
  , { infinitive: "poner", tense: Subjunctive, person: Sg1, regular: "pona" }
  , { infinitive: "poner", tense: Subjunctive, person: Sg2, regular: "ponas" }
  , { infinitive: "poner", tense: Subjunctive, person: Sg3, regular: "pona" }
  , { infinitive: "poner", tense: Subjunctive, person: Pl1, regular: "ponamos" }
  , { infinitive: "poner", tense: Subjunctive, person: Pl3, regular: "ponan" }
  , { infinitive: "venir", tense: Present, person: Sg1, regular: "veno" }
  , { infinitive: "venir", tense: Present, person: Sg2, regular: "venes" }
  , { infinitive: "venir", tense: Present, person: Sg3, regular: "vene" }
  , { infinitive: "venir", tense: Present, person: Pl3, regular: "venen" }
  , { infinitive: "venir", tense: Preterite, person: Sg1, regular: "vení" }
  , { infinitive: "venir", tense: Preterite, person: Sg2, regular: "veniste" }
  , { infinitive: "venir", tense: Preterite, person: Sg3, regular: "venió" }
  , { infinitive: "venir", tense: Preterite, person: Pl1, regular: "venimos" }
  , { infinitive: "venir", tense: Preterite, person: Pl3, regular: "venieron" }
  , { infinitive: "venir", tense: Subjunctive, person: Sg1, regular: "vena" }
  , { infinitive: "venir", tense: Subjunctive, person: Sg2, regular: "venas" }
  , { infinitive: "venir", tense: Subjunctive, person: Sg3, regular: "vena" }
  , { infinitive: "venir", tense: Subjunctive, person: Pl1, regular: "venamos" }
  , { infinitive: "venir", tense: Subjunctive, person: Pl3, regular: "venan" }
  , { infinitive: "querer", tense: Present, person: Sg1, regular: "quero" }
  , { infinitive: "querer", tense: Present, person: Sg2, regular: "queres" }
  , { infinitive: "querer", tense: Present, person: Sg3, regular: "quere" }
  , { infinitive: "querer", tense: Present, person: Pl3, regular: "queren" }
  , { infinitive: "querer", tense: Preterite, person: Sg1, regular: "querí" }
  , { infinitive: "querer", tense: Preterite, person: Sg2, regular: "queriste" }
  , { infinitive: "querer", tense: Preterite, person: Sg3, regular: "querió" }
  , { infinitive: "querer", tense: Preterite, person: Pl1, regular: "querimos" }
  , { infinitive: "querer", tense: Preterite, person: Pl3, regular: "querieron" }
  , { infinitive: "querer", tense: Subjunctive, person: Sg1, regular: "quera" }
  , { infinitive: "querer", tense: Subjunctive, person: Sg2, regular: "queras" }
  , { infinitive: "querer", tense: Subjunctive, person: Sg3, regular: "quera" }
  , { infinitive: "querer", tense: Subjunctive, person: Pl3, regular: "queran" }
  , { infinitive: "saber", tense: Present, person: Sg1, regular: "sabo" }
  , { infinitive: "saber", tense: Preterite, person: Sg1, regular: "sabí" }
  , { infinitive: "saber", tense: Preterite, person: Sg2, regular: "sabiste" }
  , { infinitive: "saber", tense: Preterite, person: Sg3, regular: "sabió" }
  , { infinitive: "saber", tense: Preterite, person: Pl1, regular: "sabimos" }
  , { infinitive: "saber", tense: Preterite, person: Pl3, regular: "sabieron" }
  , { infinitive: "saber", tense: Subjunctive, person: Sg1, regular: "saba" }
  , { infinitive: "saber", tense: Subjunctive, person: Sg2, regular: "sabas" }
  , { infinitive: "saber", tense: Subjunctive, person: Sg3, regular: "saba" }
  , { infinitive: "saber", tense: Subjunctive, person: Pl1, regular: "sabamos" }
  , { infinitive: "saber", tense: Subjunctive, person: Pl3, regular: "saban" }
  , { infinitive: "ver", tense: Present, person: Sg1, regular: "vo" }
  , { infinitive: "ver", tense: Imperfect, person: Sg1, regular: "vía" }
  , { infinitive: "ver", tense: Imperfect, person: Sg2, regular: "vías" }
  , { infinitive: "ver", tense: Imperfect, person: Sg3, regular: "vía" }
  , { infinitive: "ver", tense: Imperfect, person: Pl1, regular: "víamos" }
  , { infinitive: "ver", tense: Imperfect, person: Pl3, regular: "vían" }
  , { infinitive: "ver", tense: Subjunctive, person: Sg1, regular: "va" }
  , { infinitive: "ver", tense: Subjunctive, person: Sg2, regular: "vas" }
  , { infinitive: "ver", tense: Subjunctive, person: Sg3, regular: "va" }
  , { infinitive: "ver", tense: Subjunctive, person: Pl1, regular: "vamos" }
  , { infinitive: "ver", tense: Subjunctive, person: Pl3, regular: "van" }
  , { infinitive: "dar", tense: Present, person: Sg1, regular: "do" }
  , { infinitive: "dar", tense: Preterite, person: Sg1, regular: "de" }
  , { infinitive: "dar", tense: Preterite, person: Sg2, regular: "daste" }
  , { infinitive: "dar", tense: Preterite, person: Sg3, regular: "do" }
  , { infinitive: "dar", tense: Preterite, person: Pl1, regular: "damos" }
  , { infinitive: "dar", tense: Preterite, person: Pl3, regular: "daron" }
  , { infinitive: "dar", tense: Subjunctive, person: Sg1, regular: "de" }
  , { infinitive: "dar", tense: Subjunctive, person: Sg3, regular: "de" }
  , { infinitive: "salir", tense: Present, person: Sg1, regular: "salo" }
  , { infinitive: "salir", tense: Subjunctive, person: Sg1, regular: "sala" }
  , { infinitive: "salir", tense: Subjunctive, person: Sg2, regular: "salas" }
  , { infinitive: "salir", tense: Subjunctive, person: Sg3, regular: "sala" }
  , { infinitive: "salir", tense: Subjunctive, person: Pl1, regular: "salamos" }
  , { infinitive: "salir", tense: Subjunctive, person: Pl3, regular: "salan" }
  , { infinitive: "traer", tense: Present, person: Sg1, regular: "trao" }
  , { infinitive: "traer", tense: Preterite, person: Sg1, regular: "traí" }
  , { infinitive: "traer", tense: Preterite, person: Sg2, regular: "traiste" }
  , { infinitive: "traer", tense: Preterite, person: Sg3, regular: "traio" }
  , { infinitive: "traer", tense: Preterite, person: Pl1, regular: "traimos" }
  , { infinitive: "traer", tense: Preterite, person: Pl3, regular: "traieron" }
  , { infinitive: "traer", tense: Subjunctive, person: Sg1, regular: "traa" }
  , { infinitive: "traer", tense: Subjunctive, person: Sg2, regular: "traas" }
  , { infinitive: "traer", tense: Subjunctive, person: Sg3, regular: "traa" }
  , { infinitive: "traer", tense: Subjunctive, person: Pl1, regular: "traamos" }
  , { infinitive: "traer", tense: Subjunctive, person: Pl3, regular: "traan" }
  , { infinitive: "caber", tense: Present, person: Sg1, regular: "cabo" }
  , { infinitive: "caber", tense: Preterite, person: Sg1, regular: "cabí" }
  , { infinitive: "caber", tense: Preterite, person: Sg2, regular: "cabiste" }
  , { infinitive: "caber", tense: Preterite, person: Sg3, regular: "cabió" }
  , { infinitive: "caber", tense: Preterite, person: Pl1, regular: "cabimos" }
  , { infinitive: "caber", tense: Preterite, person: Pl3, regular: "cabieron" }
  , { infinitive: "caber", tense: Subjunctive, person: Sg1, regular: "caba" }
  , { infinitive: "caber", tense: Subjunctive, person: Sg2, regular: "cabas" }
  , { infinitive: "caber", tense: Subjunctive, person: Sg3, regular: "caba" }
  , { infinitive: "caber", tense: Subjunctive, person: Pl1, regular: "cabamos" }
  , { infinitive: "caber", tense: Subjunctive, person: Pl3, regular: "caban" }
  , { infinitive: "valer", tense: Present, person: Sg1, regular: "valo" }
  , { infinitive: "valer", tense: Subjunctive, person: Sg1, regular: "vala" }
  , { infinitive: "valer", tense: Subjunctive, person: Sg2, regular: "valas" }
  , { infinitive: "valer", tense: Subjunctive, person: Sg3, regular: "vala" }
  , { infinitive: "valer", tense: Subjunctive, person: Pl1, regular: "valamos" }
  , { infinitive: "valer", tense: Subjunctive, person: Pl3, regular: "valan" }
  , { infinitive: "oír", tense: Present, person: Sg1, regular: "oo" }
  , { infinitive: "oír", tense: Present, person: Sg2, regular: "oes" }
  , { infinitive: "oír", tense: Present, person: Sg3, regular: "oe" }
  , { infinitive: "oír", tense: Present, person: Pl1, regular: "oimos" }
  , { infinitive: "oír", tense: Present, person: Pl3, regular: "oen" }
  , { infinitive: "oír", tense: Preterite, person: Sg2, regular: "oiste" }
  , { infinitive: "oír", tense: Preterite, person: Sg3, regular: "oio" }
  , { infinitive: "oír", tense: Preterite, person: Pl1, regular: "oimos" }
  , { infinitive: "oír", tense: Preterite, person: Pl3, regular: "oieron" }
  , { infinitive: "oír", tense: Subjunctive, person: Sg1, regular: "oa" }
  , { infinitive: "oír", tense: Subjunctive, person: Sg2, regular: "oas" }
  , { infinitive: "oír", tense: Subjunctive, person: Sg3, regular: "oa" }
  , { infinitive: "oír", tense: Subjunctive, person: Pl1, regular: "oamos" }
  , { infinitive: "oír", tense: Subjunctive, person: Pl3, regular: "oan" }
  , { infinitive: "conducir", tense: Present, person: Sg1, regular: "conduco" }
  , { infinitive: "conducir", tense: Preterite, person: Sg1, regular: "conducí" }
  , { infinitive: "conducir", tense: Preterite, person: Sg2, regular: "conduciste" }
  , { infinitive: "conducir", tense: Preterite, person: Sg3, regular: "condució" }
  , { infinitive: "conducir", tense: Preterite, person: Pl1, regular: "conducimos" }
  , { infinitive: "conducir", tense: Preterite, person: Pl3, regular: "conducieron" }
  , { infinitive: "conducir", tense: Subjunctive, person: Sg1, regular: "conduca" }
  , { infinitive: "conducir", tense: Subjunctive, person: Sg2, regular: "conducas" }
  , { infinitive: "conducir", tense: Subjunctive, person: Sg3, regular: "conduca" }
  , { infinitive: "conducir", tense: Subjunctive, person: Pl1, regular: "conducamos" }
  , { infinitive: "conducir", tense: Subjunctive, person: Pl3, regular: "conducan" }
  , { infinitive: "pensar", tense: Present, person: Sg1, regular: "penso" }
  , { infinitive: "pensar", tense: Present, person: Sg2, regular: "pensas" }
  , { infinitive: "pensar", tense: Present, person: Sg3, regular: "pensa" }
  , { infinitive: "pensar", tense: Present, person: Pl3, regular: "pensan" }
  , { infinitive: "pensar", tense: Subjunctive, person: Sg1, regular: "pense" }
  , { infinitive: "pensar", tense: Subjunctive, person: Sg2, regular: "penses" }
  , { infinitive: "pensar", tense: Subjunctive, person: Sg3, regular: "pense" }
  , { infinitive: "pensar", tense: Subjunctive, person: Pl3, regular: "pensen" }
  , { infinitive: "volver", tense: Present, person: Sg1, regular: "volvo" }
  , { infinitive: "volver", tense: Present, person: Sg2, regular: "volves" }
  , { infinitive: "volver", tense: Present, person: Sg3, regular: "volve" }
  , { infinitive: "volver", tense: Present, person: Pl3, regular: "volven" }
  , { infinitive: "volver", tense: Subjunctive, person: Sg1, regular: "volva" }
  , { infinitive: "volver", tense: Subjunctive, person: Sg2, regular: "volvas" }
  , { infinitive: "volver", tense: Subjunctive, person: Sg3, regular: "volva" }
  , { infinitive: "volver", tense: Subjunctive, person: Pl3, regular: "volvan" }
  , { infinitive: "pedir", tense: Present, person: Sg1, regular: "pedo" }
  , { infinitive: "pedir", tense: Present, person: Sg2, regular: "pedes" }
  , { infinitive: "pedir", tense: Present, person: Sg3, regular: "pede" }
  , { infinitive: "pedir", tense: Present, person: Pl3, regular: "peden" }
  , { infinitive: "pedir", tense: Preterite, person: Sg3, regular: "pedió" }
  , { infinitive: "pedir", tense: Preterite, person: Pl3, regular: "pedieron" }
  , { infinitive: "pedir", tense: Subjunctive, person: Sg1, regular: "peda" }
  , { infinitive: "pedir", tense: Subjunctive, person: Sg2, regular: "pedas" }
  , { infinitive: "pedir", tense: Subjunctive, person: Sg3, regular: "peda" }
  , { infinitive: "pedir", tense: Subjunctive, person: Pl1, regular: "pedamos" }
  , { infinitive: "pedir", tense: Subjunctive, person: Pl3, regular: "pedan" }
  , { infinitive: "dormir", tense: Present, person: Sg1, regular: "dormo" }
  , { infinitive: "dormir", tense: Present, person: Sg2, regular: "dormes" }
  , { infinitive: "dormir", tense: Present, person: Sg3, regular: "dorme" }
  , { infinitive: "dormir", tense: Present, person: Pl3, regular: "dormen" }
  , { infinitive: "dormir", tense: Preterite, person: Sg3, regular: "dormió" }
  , { infinitive: "dormir", tense: Preterite, person: Pl3, regular: "dormieron" }
  , { infinitive: "dormir", tense: Subjunctive, person: Sg1, regular: "dorma" }
  , { infinitive: "dormir", tense: Subjunctive, person: Sg2, regular: "dormas" }
  , { infinitive: "dormir", tense: Subjunctive, person: Sg3, regular: "dorma" }
  , { infinitive: "dormir", tense: Subjunctive, person: Pl1, regular: "dormamos" }
  , { infinitive: "dormir", tense: Subjunctive, person: Pl3, regular: "dorman" }
  , { infinitive: "jugar", tense: Present, person: Sg1, regular: "jugo" }
  , { infinitive: "jugar", tense: Present, person: Sg2, regular: "jugas" }
  , { infinitive: "jugar", tense: Present, person: Sg3, regular: "juga" }
  , { infinitive: "jugar", tense: Present, person: Pl3, regular: "jugan" }
  , { infinitive: "jugar", tense: Preterite, person: Sg1, regular: "jugé" }
  , { infinitive: "jugar", tense: Subjunctive, person: Sg1, regular: "juge" }
  , { infinitive: "jugar", tense: Subjunctive, person: Sg2, regular: "juges" }
  , { infinitive: "jugar", tense: Subjunctive, person: Sg3, regular: "juge" }
  , { infinitive: "jugar", tense: Subjunctive, person: Pl1, regular: "jugemos" }
  , { infinitive: "jugar", tense: Subjunctive, person: Pl3, regular: "jugen" }
  , { infinitive: "llegar", tense: Preterite, person: Sg1, regular: "llegé" }
  , { infinitive: "llegar", tense: Subjunctive, person: Sg1, regular: "llege" }
  , { infinitive: "llegar", tense: Subjunctive, person: Sg2, regular: "lleges" }
  , { infinitive: "llegar", tense: Subjunctive, person: Sg3, regular: "llege" }
  , { infinitive: "llegar", tense: Subjunctive, person: Pl1, regular: "llegemos" }
  , { infinitive: "llegar", tense: Subjunctive, person: Pl3, regular: "llegen" }
  , { infinitive: "buscar", tense: Preterite, person: Sg1, regular: "buscé" }
  , { infinitive: "buscar", tense: Subjunctive, person: Sg1, regular: "busce" }
  , { infinitive: "buscar", tense: Subjunctive, person: Sg2, regular: "busces" }
  , { infinitive: "buscar", tense: Subjunctive, person: Sg3, regular: "busce" }
  , { infinitive: "buscar", tense: Subjunctive, person: Pl1, regular: "buscemos" }
  , { infinitive: "buscar", tense: Subjunctive, person: Pl3, regular: "buscen" }
  , { infinitive: "empezar", tense: Present, person: Sg1, regular: "empezo" }
  , { infinitive: "empezar", tense: Present, person: Sg2, regular: "empezas" }
  , { infinitive: "empezar", tense: Present, person: Sg3, regular: "empeza" }
  , { infinitive: "empezar", tense: Present, person: Pl3, regular: "empezan" }
  , { infinitive: "empezar", tense: Preterite, person: Sg1, regular: "empezé" }
  , { infinitive: "empezar", tense: Subjunctive, person: Sg1, regular: "empeze" }
  , { infinitive: "empezar", tense: Subjunctive, person: Sg2, regular: "empezes" }
  , { infinitive: "empezar", tense: Subjunctive, person: Sg3, regular: "empeze" }
  , { infinitive: "empezar", tense: Subjunctive, person: Pl1, regular: "empezemos" }
  , { infinitive: "empezar", tense: Subjunctive, person: Pl3, regular: "empezen" }
  , { infinitive: "andar", tense: Preterite, person: Sg1, regular: "andé" }
  , { infinitive: "andar", tense: Preterite, person: Sg2, regular: "andaste" }
  , { infinitive: "andar", tense: Preterite, person: Sg3, regular: "andó" }
  , { infinitive: "andar", tense: Preterite, person: Pl1, regular: "andamos" }
  , { infinitive: "andar", tense: Preterite, person: Pl3, regular: "andaron" }
  , { infinitive: "caer", tense: Present, person: Sg1, regular: "cao" }
  , { infinitive: "caer", tense: Preterite, person: Sg2, regular: "caiste" }
  , { infinitive: "caer", tense: Preterite, person: Sg3, regular: "caio" }
  , { infinitive: "caer", tense: Preterite, person: Pl1, regular: "caimos" }
  , { infinitive: "caer", tense: Preterite, person: Pl3, regular: "caieron" }
  , { infinitive: "caer", tense: Subjunctive, person: Sg1, regular: "caa" }
  , { infinitive: "caer", tense: Subjunctive, person: Sg2, regular: "caas" }
  , { infinitive: "caer", tense: Subjunctive, person: Sg3, regular: "caa" }
  , { infinitive: "caer", tense: Subjunctive, person: Pl1, regular: "caamos" }
  , { infinitive: "caer", tense: Subjunctive, person: Pl3, regular: "caan" }
  , { infinitive: "conocer", tense: Present, person: Sg1, regular: "conoco" }
  , { infinitive: "conocer", tense: Subjunctive, person: Sg1, regular: "conoca" }
  , { infinitive: "conocer", tense: Subjunctive, person: Sg2, regular: "conocas" }
  , { infinitive: "conocer", tense: Subjunctive, person: Sg3, regular: "conoca" }
  , { infinitive: "conocer", tense: Subjunctive, person: Pl1, regular: "conocamos" }
  , { infinitive: "conocer", tense: Subjunctive, person: Pl3, regular: "conocan" }
  , { infinitive: "leer", tense: Preterite, person: Sg2, regular: "leiste" }
  , { infinitive: "leer", tense: Preterite, person: Sg3, regular: "leio" }
  , { infinitive: "leer", tense: Preterite, person: Pl1, regular: "leimos" }
  , { infinitive: "leer", tense: Preterite, person: Pl3, regular: "leieron" }
  , { infinitive: "construir", tense: Present, person: Sg1, regular: "construo" }
  , { infinitive: "construir", tense: Present, person: Sg2, regular: "construes" }
  , { infinitive: "construir", tense: Present, person: Sg3, regular: "construe" }
  , { infinitive: "construir", tense: Present, person: Pl3, regular: "construen" }
  , { infinitive: "construir", tense: Preterite, person: Sg3, regular: "construió" }
  , { infinitive: "construir", tense: Preterite, person: Pl3, regular: "construieron" }
  , { infinitive: "construir", tense: Subjunctive, person: Sg1, regular: "construa" }
  , { infinitive: "construir", tense: Subjunctive, person: Sg2, regular: "construas" }
  , { infinitive: "construir", tense: Subjunctive, person: Sg3, regular: "construa" }
  , { infinitive: "construir", tense: Subjunctive, person: Pl1, regular: "construamos" }
  , { infinitive: "construir", tense: Subjunctive, person: Pl3, regular: "construan" }
  , { infinitive: "reír", tense: Present, person: Sg1, regular: "reo" }
  , { infinitive: "reír", tense: Present, person: Sg2, regular: "rees" }
  , { infinitive: "reír", tense: Present, person: Sg3, regular: "ree" }
  , { infinitive: "reír", tense: Present, person: Pl1, regular: "reimos" }
  , { infinitive: "reír", tense: Present, person: Pl3, regular: "reen" }
  , { infinitive: "reír", tense: Preterite, person: Sg2, regular: "reiste" }
  , { infinitive: "reír", tense: Preterite, person: Sg3, regular: "reio" }
  , { infinitive: "reír", tense: Preterite, person: Pl1, regular: "reimos" }
  , { infinitive: "reír", tense: Preterite, person: Pl3, regular: "reieron" }
  , { infinitive: "reír", tense: Subjunctive, person: Sg1, regular: "rea" }
  , { infinitive: "reír", tense: Subjunctive, person: Sg2, regular: "reas" }
  , { infinitive: "reír", tense: Subjunctive, person: Sg3, regular: "rea" }
  , { infinitive: "reír", tense: Subjunctive, person: Pl1, regular: "reamos" }
  , { infinitive: "reír", tense: Subjunctive, person: Pl3, regular: "rean" }
  , { infinitive: "seguir", tense: Present, person: Sg1, regular: "seguo" }
  , { infinitive: "seguir", tense: Present, person: Sg2, regular: "segues" }
  , { infinitive: "seguir", tense: Present, person: Sg3, regular: "segue" }
  , { infinitive: "seguir", tense: Present, person: Pl3, regular: "seguen" }
  , { infinitive: "seguir", tense: Preterite, person: Sg3, regular: "seguió" }
  , { infinitive: "seguir", tense: Preterite, person: Pl3, regular: "seguieron" }
  , { infinitive: "seguir", tense: Subjunctive, person: Sg1, regular: "segua" }
  , { infinitive: "seguir", tense: Subjunctive, person: Sg2, regular: "seguas" }
  , { infinitive: "seguir", tense: Subjunctive, person: Sg3, regular: "segua" }
  , { infinitive: "seguir", tense: Subjunctive, person: Pl1, regular: "seguamos" }
  , { infinitive: "seguir", tense: Subjunctive, person: Pl3, regular: "seguan" }
  , { infinitive: "sentir", tense: Present, person: Sg1, regular: "sento" }
  , { infinitive: "sentir", tense: Present, person: Sg2, regular: "sentes" }
  , { infinitive: "sentir", tense: Present, person: Sg3, regular: "sente" }
  , { infinitive: "sentir", tense: Present, person: Pl3, regular: "senten" }
  , { infinitive: "sentir", tense: Preterite, person: Sg3, regular: "sentió" }
  , { infinitive: "sentir", tense: Preterite, person: Pl3, regular: "sentieron" }
  , { infinitive: "sentir", tense: Subjunctive, person: Sg1, regular: "senta" }
  , { infinitive: "sentir", tense: Subjunctive, person: Sg2, regular: "sentas" }
  , { infinitive: "sentir", tense: Subjunctive, person: Sg3, regular: "senta" }
  , { infinitive: "sentir", tense: Subjunctive, person: Pl1, regular: "sentamos" }
  , { infinitive: "sentir", tense: Subjunctive, person: Pl3, regular: "sentan" }
  , { infinitive: "morir", tense: Present, person: Sg1, regular: "moro" }
  , { infinitive: "morir", tense: Present, person: Sg2, regular: "mores" }
  , { infinitive: "morir", tense: Present, person: Sg3, regular: "more" }
  , { infinitive: "morir", tense: Present, person: Pl3, regular: "moren" }
  , { infinitive: "morir", tense: Preterite, person: Sg3, regular: "morió" }
  , { infinitive: "morir", tense: Preterite, person: Pl3, regular: "morieron" }
  , { infinitive: "morir", tense: Subjunctive, person: Sg1, regular: "mora" }
  , { infinitive: "morir", tense: Subjunctive, person: Sg2, regular: "moras" }
  , { infinitive: "morir", tense: Subjunctive, person: Sg3, regular: "mora" }
  , { infinitive: "morir", tense: Subjunctive, person: Pl1, regular: "moramos" }
  , { infinitive: "morir", tense: Subjunctive, person: Pl3, regular: "moran" }
  , { infinitive: "oler", tense: Present, person: Sg1, regular: "olo" }
  , { infinitive: "oler", tense: Present, person: Sg2, regular: "oles" }
  , { infinitive: "oler", tense: Present, person: Sg3, regular: "ole" }
  , { infinitive: "oler", tense: Present, person: Pl3, regular: "olen" }
  , { infinitive: "oler", tense: Subjunctive, person: Sg1, regular: "ola" }
  , { infinitive: "oler", tense: Subjunctive, person: Sg2, regular: "olas" }
  , { infinitive: "oler", tense: Subjunctive, person: Sg3, regular: "ola" }
  , { infinitive: "oler", tense: Subjunctive, person: Pl3, regular: "olan" }
  , { infinitive: "elegir", tense: Present, person: Sg1, regular: "elego" }
  , { infinitive: "elegir", tense: Present, person: Sg2, regular: "eleges" }
  , { infinitive: "elegir", tense: Present, person: Sg3, regular: "elege" }
  , { infinitive: "elegir", tense: Present, person: Pl3, regular: "elegen" }
  , { infinitive: "elegir", tense: Preterite, person: Sg3, regular: "elegió" }
  , { infinitive: "elegir", tense: Preterite, person: Pl3, regular: "elegieron" }
  , { infinitive: "elegir", tense: Subjunctive, person: Sg1, regular: "elega" }
  , { infinitive: "elegir", tense: Subjunctive, person: Sg2, regular: "elegas" }
  , { infinitive: "elegir", tense: Subjunctive, person: Sg3, regular: "elega" }
  , { infinitive: "elegir", tense: Subjunctive, person: Pl1, regular: "elegamos" }
  , { infinitive: "elegir", tense: Subjunctive, person: Pl3, regular: "elegan" }
  ]
